export default {
  translation: {
    // Common
    "app.name": "Give Protocol",
    "app.tagline": "โครงสร้างพื้นฐานที่โปร่งใสและไร้พรมแดนเพื่อการให้",
    "common.skipToMainContent": "ข้ามไปที่เนื้อหาหลัก",
    "common.cancel": "ยกเลิก",
    "common.edit": "แก้ไข",
    "common.delete": "ลบ",
    "common.creating": "กำลังสร้าง...",
    "common.unknown": "ไม่ทราบ",
    "common.notAvailable": "ไม่มีข้อมูล",

    // Navigation
    "nav.browse": "ค้นหาองค์กรการกุศล",
    "nav.opportunities": "โอกาสอาสาสมัคร",
    "nav.contributions": "ติดตามการมีส่วนร่วม",
    "nav.governance": "การกำกับดูแล",
    "nav.dashboard": "แดชบอร์ด Give",
    "nav.about": "เกี่ยวกับเรา",
    "nav.docs": "เอกสาร",
    "nav.legal": "ข้อมูลทางกฎหมาย",
    "nav.launchApp": "เปิดแอป",

    // FAQ page (GIV-988)
    "faq.title": "คำถามที่พบบ่อย",
    "faq.subtitle":
      "ทุกสิ่งที่คุณต้องรู้เกี่ยวกับการบริจาค การเป็นอาสาสมัคร และความโปร่งใสของบล็อกเชน",

    // Settings
    "settings.title": "การตั้งค่า",
    "settings.language": "ภาษา",
    "settings.currency": "สกุลเงิน",

    // Auth
    "auth.login": "เข้าสู่ระบบ",
    "auth.register": "สร้างบัญชี",
    "auth.logout": "ออกจากระบบ",
    "auth.forgotPassword": "ลืมรหัสผ่าน?",

    // Dashboard
    "dashboard.title": "แดชบอร์ด Give",
    "dashboard.subtitle": "ติดตามการบริจาคและการมีส่วนร่วมของอาสาสมัคร",
    "dashboard.totalDonations": "ยอดบริจาครวม",
    "dashboard.volunteerHours": "ชั่วโมงอาสาสมัคร",
    "dashboard.skillsEndorsed": "ทักษะที่ได้รับการรับรอง",
    "dashboard.contributions": "การมีส่วนร่วม",
    "dashboard.yourTotalDonated": "ยอดบริจาคของคุณ",
    "dashboard.yourVolunteerHours": "ชั่วโมงอาสาสมัครของคุณ",
    "dashboard.yourSkillsEndorsed": "ทักษะที่คุณได้รับการรับรอง",
    "dashboard.impactGrowth": "การเติบโตของผลกระทบ",
    "dashboard.charitiesSupported": "องค์กรการกุศลที่สนับสนุน",

    // Charity
    "charity.dashboard": "แดชบอร์ดองค์กรการกุศล",
    "charity.subtitle": "จัดการการบริจาคและโปรแกรมอาสาสมัคร",
    "charity.activeVolunteers": "อาสาสมัครที่ใช้งานอยู่",
    "charity.transactions": "ธุรกรรม",
    "charity.volunteers": "ชั่วโมงอาสาสมัคร",
    "charity.applications": "การสมัคร",
    "charity.totalReceived": "ยอดรับรวม",
    "charity.equityPoolValue": "มูลค่ากองทุนส่วนร่วม",
    "charity.availableBalance": "ยอดคงเหลือที่ใช้ได้",

    // Contributions
    "contributions.date": "วันที่",
    "contributions.type": "ประเภท",
    "contributions.organization": "องค์กร",
    "contributions.details": "รายละเอียด",
    "contributions.status": "สถานะ",
    "contributions.verification": "การตรวจสอบ",
    "contributions.export": "ส่งออก CSV",

    // Volunteer
    "volunteer.opportunities": "โอกาสอาสาสมัคร",
    "volunteer.searchOpportunities": "ค้นหาโอกาส...",
    "volunteer.selectSkill": "เลือกทักษะ",
    "volunteer.selectType": "เลือกประเภท",
    "volunteer.selectLanguage": "เลือกภาษา",
    "volunteer.allSkills": "ทักษะทั้งหมด",
    "volunteer.allTypes": "ประเภททั้งหมด",
    "volunteer.allLanguages": "ทุกภาษา",
    "volunteer.applyNow": "สมัครเลย",
    "volunteer.noOpportunitiesFound": "ไม่พบโอกาสที่ตรงกับเกณฑ์ของคุณ",
    "volunteer.verify": "ตรวจสอบชั่วโมง",
    "volunteer.verifying": "กำลังตรวจสอบ...",
    "volunteer.reject": "ปฏิเสธ",
    "volunteer.accept": "ยอมรับ",
    "volunteer.processing": "กำลังดำเนินการ...",
    "volunteer.hours": "ชั่วโมงเมื่อ",
    "volunteer.description": "คำอธิบาย",
    "volunteer.appliedFor": "สมัครสำหรับ",
    "volunteer.verificationComplete": "การตรวจสอบเสร็จสมบูรณ์",
    "volunteer.hoursVerified":
      "ชั่วโมงอาสาสมัครได้รับการตรวจสอบและบันทึกบนบล็อกเชนแล้ว",
    "volunteer.verificationHash": "แฮชการตรวจสอบ",
    "volunteer.applicationAccepted": "การสมัครได้รับการยอมรับ",
    "volunteer.applicationRecorded":
      "การสมัครอาสาสมัครได้รับการยอมรับและบันทึกบนบล็อกเชนแล้ว",
    "volunteer.acceptanceHash": "แฮชการยอมรับ",
    "volunteer.pendingHours": "ชั่วโมงอาสาสมัครที่รอดำเนินการ",
    "volunteer.noPendingHours": "ไม่มีชั่วโมงอาสาสมัครที่รอการตรวจสอบ",
    "volunteer.pendingApplications": "การสมัครที่รอดำเนินการ",
    "volunteer.noPendingApplications": "ไม่มีการสมัครที่รอการตรวจสอบ",
    "volunteer.createOpportunity": "สร้างโอกาสอาสาสมัคร",
    "volunteer.createNew": "สร้างใหม่",
    "volunteer.noOpportunitiesYet":
      'ยังไม่มีโอกาสที่สร้างขึ้น คลิก "สร้างใหม่" เพื่อเริ่มต้น',
    "volunteer.opportunityTitle": "ชื่อโอกาส",
    "volunteer.skills": "ทักษะ (คั่นด้วยเครื่องหมายจุลภาค)",
    "volunteer.commitment": "ระดับความมุ่งมั่น",
    "volunteer.location": "สถานที่",
    "volunteer.type": "ประเภท",
    "volunteer.workLanguage": "ภาษาในการทำงาน",
    "volunteer.status": "สถานะ",

    // Volunteer commitment types
    "volunteer.commitment.oneTime": "ครั้งเดียว",
    "volunteer.commitment.shortTerm": "ระยะสั้น",
    "volunteer.commitment.longTerm": "ระยะยาว",

    // Volunteer types
    "volunteer.type.remote": "ทำงานระยะไกล",
    "volunteer.type.onsite": "ทำงานที่สถานที่",
    "volunteer.type.hybrid": "ผสมผสาน",
    "volunteer.type.onSite": "ทำงานที่สถานที่",

    // Volunteer - Opportunities page
    "volunteer.workTypeFilter": "ตัวกรองประเภทงาน",
    "volunteer.searchLocation": "เมืองหรือภูมิภาค...",
    "volunteer.searchLocationAria": "ค้นหาสถานที่",
    "volunteer.filter.skill": "ทักษะ: {{value}}",
    "volunteer.filter.type": "ประเภท: {{value}}",
    "volunteer.filter.language": "ภาษา: {{value}}",
    "volunteer.filter.location": "สถานที่: {{value}}",
    "volunteer.loadingOpportunities": "กำลังโหลดโอกาส...",
    "volunteer.loadOpportunitiesError": "ไม่สามารถโหลดโอกาสการเป็นอาสาสมัครได้ โปรดลองอีกครั้งในภายหลัง",
    "volunteer.viewDetails": "ดูรายละเอียด",
    "volunteer.backToOpportunities": "กลับไปยังโอกาสทั้งหมด",
    "volunteer.detail.about": "เกี่ยวกับโอกาสนี้",
    "volunteer.detail.skills": "ทักษะที่ต้องการ",
    "volunteer.detail.commitment": "เวลาที่ต้องใช้",
    "volunteer.detail.location": "สถานที่",
    "volunteer.detail.language": "ภาษา",
    "volunteer.detail.hostedBy": "จัดโดย",
    "volunteer.detail.ongoing": "ต่อเนื่อง",
    "volunteer.detail.applicationsClosed": "ปิดรับสมัครแล้ว",
    "volunteer.detail.notFoundTitle": "ไม่พบโอกาสนี้",
    "volunteer.detail.notFoundMessage": "โอกาสนี้อาจเต็มแล้วหรือถูกลบออก",
    "volunteer.field.requirements": "คุณสมบัติที่ต้องการ",
    "volunteer.field.benefits": "สิทธิประโยชน์",
    "volunteer.field.schedule": "ตารางเวลา",
    "volunteer.field.schedulePlaceholder": "เช่น วันอังคาร 18:00-20:00 น. ยืดหยุ่นในวันหยุดสุดสัปดาห์",
    "volunteer.field.startDate": "วันที่เริ่ม",
    "volunteer.field.endDate": "วันที่สิ้นสุด",
    "volunteer.field.endDateHelp": "เว้นว่างไว้หากต่อเนื่อง",
    "volunteer.field.applicationDeadline": "วันปิดรับสมัคร",
    "volunteer.field.volunteersNeeded": "จำนวนอาสาสมัครที่ต้องการ",
    "volunteer.field.minimumAge": "อายุขั้นต่ำ",
    "volunteer.field.backgroundCheckRequired": "ต้องตรวจสอบประวัติ",
    "volunteer.field.trainingProvided": "มีการฝึกอบรม",
    "volunteer.field.onePerLine": "หนึ่งรายการต่อบรรทัด",
    "volunteer.validation.volunteersNeeded": "กรอกตัวเลขตั้งแต่ 1 ขึ้นไป",
    "volunteer.validation.minimumAge": "กรอกอายุระหว่าง 0 ถึง 120",
    "volunteer.validation.endDate": "วันที่สิ้นสุดต้องไม่ก่อนวันที่เริ่ม",
    "volunteer.signInToApply": "กรุณาเข้าสู่ระบบเพื่อสมัครโอกาสอาสาสมัคร",
    "volunteer.applicationSuccess": "ส่งใบสมัครเรียบร้อยแล้ว!",
    "volunteer.removeFilter": "ลบตัวกรอง {{filter}}",

    // Volunteer - OpportunityForm
    "volunteer.validation.titleRequired": "จำเป็นต้องระบุชื่อ",
    "volunteer.validation.descriptionRequired": "จำเป็นต้องระบุคำอธิบาย",
    "volunteer.validation.skillsRequired":
      "จำเป็นต้องระบุทักษะอย่างน้อยหนึ่งรายการ",
    "volunteer.validation.locationRequired": "จำเป็นต้องระบุสถานที่",
    "volunteer.profileNotFound": "ไม่พบโปรไฟล์ผู้ใช้",
    "volunteer.correctErrors": "กรุณาแก้ไขข้อผิดพลาดในการตรวจสอบ",
    "volunteer.createFailed": "ไม่สามารถสร้างโอกาสได้",
    "volunteer.descriptionPlaceholder": "อธิบายโอกาสอาสาสมัครโดยละเอียด...",
    "volunteer.skillsPlaceholder": "เช่น พัฒนาเว็บ, จัดการโครงการ, การแปล",
    "volunteer.locationPlaceholder": "เช่น ทำงานระยะไกล, กรุงเทพฯ, เชียงใหม่",
    "volunteer.headerImage": "รูปภาพส่วนหัว",
    "volunteer.headerImageHelp":
      "อัปโหลดรูปภาพเพื่อแสดงที่ด้านบนของรายการโอกาสของคุณ",
    "volunteer.limitReached": "ถึงขีดจำกัดโอกาสแล้ว",
    "volunteer.limitReachedMessage":
      "คุณมีโอกาสอาสาสมัครที่ใช้งานอยู่ถึงจำนวนสูงสุด {{max}} รายการแล้ว กรุณาปิดหรือดำเนินการโอกาสที่มีอยู่ให้เสร็จก่อนสร้างรายการใหม่",
    "volunteer.opportunityCount":
      "คุณมีโอกาสที่ใช้งานอยู่ {{count}} จาก {{max}} รายการ",

    // Volunteer - HoursVerificationTab
    "volunteer.hoursVerification": "การตรวจสอบชั่วโมง",
    "volunteer.hoursVerificationDescription":
      "ตรวจสอบและยืนยันการส่งชั่วโมงอาสาสมัคร",
    "volunteer.formalHours": "ชั่วโมงที่บันทึก",
    "volunteer.selfReported": "รายงานด้วยตนเอง",
    "volunteer.loggedHours": "ชั่วโมงอาสาสมัครที่บันทึก",
    "volunteer.loggedHoursDescription":
      "ชั่วโมงที่บันทึกโดยอาสาสมัครผ่านโอกาสของคุณ",
    "volunteer.allCaughtUp": "อัปเดตครบถ้วนแล้ว!",
    "volunteer.noPendingLoggedHours": "ไม่มีชั่วโมงที่บันทึกรอการตรวจสอบ",
    "volunteer.selfReportedHours": "ชั่วโมงที่รายงานด้วยตนเอง",

    // Volunteer - OpportunitiesTab
    "volunteer.noOpportunitiesTitle": "ยังไม่มีโอกาส",
    "volunteer.activeCount": "โอกาสที่ใช้งานอยู่ {{count}} จาก {{max}} รายการ",
    "volunteer.moreSkills": "+{{count}} เพิ่มเติม",

    // Volunteer - ApplicationsTab
    "volunteer.noApplications": "ไม่มีการสมัครที่รอดำเนินการ",
    "volunteer.unknownOpportunity": "โอกาสที่ไม่ทราบ",

    // Volunteer - VerificationLookup
    "volunteer.verifyContribution": "ตรวจสอบการมีส่วนร่วมของอาสาสมัคร",
    "volunteer.hashPlaceholder": "กรอกแฮชการตรวจสอบ",
    "volunteer.searching": "กำลังค้นหา...",
    "volunteer.verifyHash": "ตรวจสอบแฮช",
    "volunteer.verificationNotFound": "ไม่พบการตรวจสอบ",
    "volunteer.verificationNotFoundMessage":
      "ไม่พบแฮชที่คุณระบุในบันทึกของเรา กรุณาตรวจสอบแฮชและลองอีกครั้ง",
    "volunteer.unknownOrganization": "องค์กรที่ไม่ทราบ",

    // Volunteer - VolunteerVerificationCard
    "volunteer.contributionVerification": "การตรวจสอบการมีส่วนร่วมของอาสาสมัคร",
    "volunteer.volunteerLabel": "อาสาสมัคร",
    "volunteer.opportunityLabel": "โอกาส",
    "volunteer.organizationLabel": "องค์กร",
    "volunteer.acceptedOn": "ยอมรับเมื่อ",
    "volunteer.verifiedOn": "ตรวจสอบเมื่อ",
    "volunteer.verificationHashes": "แฮชการตรวจสอบ",
    "volunteer.blockchainReference": "อ้างอิงบล็อกเชน",

    // Volunteer - VerifyContribution page
    "volunteer.verifyingContribution": "กำลังตรวจสอบการมีส่วนร่วม\u2026",
    "volunteer.noHashProvided": "ไม่ได้ระบุแฮชการตรวจสอบ",
    "volunteer.verificationSuccessful": "การตรวจสอบสำเร็จ",
    "volunteer.contributionVerifiedBlockchain":
      "การมีส่วนร่วมของอาสาสมัครนี้ได้รับการตรวจสอบและบันทึกบนบล็อกเชนแล้ว",
    "volunteer.verificationFailed": "การตรวจสอบล้มเหลว",
    "volunteer.hashNotFound": "ไม่พบแฮชการตรวจสอบ {{hash}} หรือไม่ถูกต้อง",

    // Volunteer - SelfReportedHoursDashboard
    "volunteer.volunteerHoursTitle": "ชั่วโมงอาสาสมัคร",
    "volunteer.aboutSelfReported": "เกี่ยวกับชั่วโมงที่รายงานด้วยตนเอง",
    "volunteer.selfReportedInfo":
      "เฉพาะชั่วโมงที่ได้รับการรับรองจากองค์กรที่ผ่านการตรวจสอบเท่านั้นที่จะนับรวมใน Global Impact Rankings ชั่วโมงสำหรับองค์กรที่ไม่อยู่ในแพลตฟอร์มของเราสามารถติดตามได้ แต่จะถูกทำเครื่องหมายเป็น \u201cไม่ผ่านการรับรอง\u201d จนกว่าจะได้รับการรับรอง",
    "volunteer.logHoursButton": "บันทึกชั่วโมง",
    "volunteer.logVolunteerHours": "บันทึกชั่วโมงอาสาสมัคร",
    "volunteer.editRecord": "แก้ไขบันทึก",
    "volunteer.recordDetails": "รายละเอียดบันทึก",
    "volunteer.backToList": "กลับไปยังรายการ",
    "volunteer.deleteRecord": "ลบบันทึก?",
    "volunteer.deleteConfirmation":
      "คุณแน่ใจหรือไม่ว่าต้องการลบบันทึกชั่วโมงอาสาสมัครนี้? การดำเนินการนี้ไม่สามารถย้อนกลับได้",

    // Volunteer - SelfReportedHoursForm
    "volunteer.activityType": "ประเภทกิจกรรม",
    "volunteer.organization": "องค์กร",
    "volunteer.searchRegistry": "ค้นหาทะเบียน",
    "volunteer.searchRegistryPlaceholder":
      "ค้นหาทะเบียนองค์กรการกุศลตามชื่อหรือเลขประจำตัวผู้เสียภาษี…",
    "volunteer.registryTaxId": "เลขประจำตัวผู้เสียภาษี {{value}}",
    "volunteer.notListed": "ไม่อยู่ในรายการ",
    "volunteer.organizationName": "ชื่อองค์กร",
    "volunteer.enterOrgName": "กรอกชื่อองค์กร",
    "volunteer.contactEmail": "อีเมลติดต่อ",
    "volunteer.contactEmailOptional": "(ไม่บังคับ)",
    "volunteer.onboardHelp": "เราอาจติดต่อเพื่อช่วยนำองค์กรนี้เข้าสู่ระบบ",
    "volunteer.submittedForValidation": "บันทึกนี้จะถูกส่งเพื่อการรับรอง",
    "volunteer.submittedForValidationTo":
      "บันทึกนี้จะถูกส่งเพื่อการรับรองไปยัง {{org}}",
    "volunteer.validationExpired":
      "ระยะเวลาการรับรองหมดอายุสำหรับวันที่นี้แล้ว",
    "volunteer.savedAsUnvalidated": "บันทึกนี้จะถูกบันทึกเป็นไม่ผ่านการรับรอง",
    "volunteer.describeActivities": "อธิบายกิจกรรมที่คุณดำเนินการ...",
    "volunteer.moreCharsNeeded": "ต้องการอีก {{count}} ตัวอักษร",
    "volunteer.updating": "กำลังอัปเดต...",
    "volunteer.logging": "กำลังบันทึก...",
    "volunteer.updateHours": "อัปเดตชั่วโมง",

    // Volunteer - SelfReportedHoursList
    "volunteer.statusFilter": "สถานะ",
    "volunteer.activityTypeFilter": "ประเภทกิจกรรม",
    "volunteer.filterFrom": "ตั้งแต่",
    "volunteer.filterTo": "ถึง",
    "volunteer.clearFilters": "ล้างตัวกรอง",
    "volunteer.allStatuses": "ทั้งหมด",
    "volunteer.allActivityTypes": "ทุกประเภท",
    "volunteer.noMatchingRecords": "ไม่พบบันทึกที่ตรงกัน",
    "volunteer.noHoursLogged": "ยังไม่มีชั่วโมงอาสาสมัครที่บันทึก",
    "volunteer.adjustFilters": "ลองปรับตัวกรองเพื่อค้นหาบันทึก",
    "volunteer.startLogging":
      "เริ่มต้นด้วยการบันทึกชั่วโมงอาสาสมัครครั้งแรกของคุณ",

    // Volunteer - SelfReportedHoursStats
    "volunteer.validatedHours": "ชั่วโมงที่ผ่านการรับรอง",
    "volunteer.pendingValidation": "รอการรับรอง",
    "volunteer.unvalidatedHours": "ชั่วโมงที่ไม่ผ่านการรับรอง",
    "volunteer.rejectedLabel": "ถูกปฏิเสธ",
    "volunteer.hoursUnit": "ชม.",
    "volunteer.recordSingular": "บันทึก",
    "volunteer.recordPlural": "บันทึก",

    // Volunteer - VolunteerApplicationForm
    "volunteer.applicationTitle": "ใบสมัครอาสาสมัคร",
    "volunteer.applicationSubtitle":
      "ช่วยสร้างผลกระทบอย่างยั่งยืนผ่านการมีส่วนร่วมที่ผ่านการตรวจสอบ",
    "volunteer.progress.info": "ข้อมูล",
    "volunteer.progress.skills": "ทักษะ",
    "volunteer.progress.consent": "ความยินยอม",
    "volunteer.fieldValid": "ดูดี",
    "volunteer.draftSaved": "บันทึกฉบับร่างแล้ว",
    "volunteer.personalInfo": "ข้อมูลส่วนบุคคล",
    "volunteer.firstName": "ชื่อ",
    "volunteer.lastName": "นามสกุล",
    "volunteer.emailAddress": "ที่อยู่อีเมล",
    "volunteer.phoneNumber": "หมายเลขโทรศัพท์",
    "volunteer.locationCity": "สถานที่/เมือง",
    "volunteer.locationCityPlaceholder": "เช่น กรุงเทพฯ",
    "volunteer.timeZone": "เขตเวลา",
    "volunteer.selectTimeZone": "เลือกเขตเวลา",
    "volunteer.ageRange": "ช่วงอายุ",
    "volunteer.selectAgeRange": "เลือกช่วงอายุ",
    "volunteer.skillsAndInterests": "ทักษะและความสนใจ",
    "volunteer.skillsLabel": "ทักษะและด้านที่สนใจ",
    "volunteer.skillPlaceholderFull":
      "เริ่มพิมพ์ทักษะของคุณ (เช่น การเขียนโปรแกรม Python, การพูดในที่สาธารณะ, การเขียนข้อเสนอทุน)",
    "volunteer.skillPlaceholderShort": "พิมพ์ทักษะแล้วกด Enter...",
    "volunteer.commitmentLevel": "ระดับความมุ่งมั่น",
    "volunteer.commitmentOneTimeDesc": "โครงการเดี่ยวหรืองานระยะสั้น",
    "volunteer.commitmentShortTermDesc": "ไม่กี่สัปดาห์ถึงไม่กี่เดือน",
    "volunteer.commitmentLongTermDesc": "ความมุ่งมั่นต่อเนื่องหลายเดือนขึ้นไป",
    "volunteer.experienceLabel": "บอกเราเกี่ยวกับประสบการณ์ที่เกี่ยวข้องของคุณ",
    "volunteer.experiencePlaceholder":
      "อธิบายภูมิหลัง ทักษะ และแรงจูงใจที่ทำให้คุณต้องการเป็นอาสาสมัครกับ Give Protocol...",
    "volunteer.consentTitle": "ความยินยอมและข้อตกลง",
    "volunteer.consentHeader": "ความยินยอมในการสมัครอาสาสมัคร",
    "volunteer.submitting": "กำลังส่ง...",
    "volunteer.submitApplication": "ส่งใบสมัครอาสาสมัคร",
    "volunteer.disclaimerText":
      "การส่งใบสมัครนี้แสดงว่าคุณรับทราบว่าคุณได้อ่านและเข้าใจนโยบายความเป็นส่วนตัวและแนวทางอาสาสมัครของ Give Protocol แล้ว ข้อมูลของคุณจะได้รับการประมวลผลตามกฎหมายคุ้มครองข้อมูลที่เกี่ยวข้อง",
    "volunteer.validation.firstNameInvalid": "กรุณากรอกชื่อที่ถูกต้อง",
    "volunteer.validation.lastNameInvalid": "กรุณากรอกนามสกุลที่ถูกต้อง",
    "volunteer.validation.emailInvalid": "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
    "volunteer.validation.phoneInvalid": "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
    "volunteer.validation.experienceRequired":
      "กรุณาอธิบายประสบการณ์ที่เกี่ยวข้องของคุณ",
    "volunteer.validation.addSkill": "กรุณาเพิ่มทักษะอย่างน้อยหนึ่งรายการ",
    "volunteer.validation.ageRangeRequired": "กรุณาเลือกช่วงอายุของคุณ",
    "volunteer.validation.consentRequired":
      "คุณต้องยอมรับรายการความยินยอมที่จำเป็นทั้งหมด",
    "volunteer.signInToSubmit": "กรุณาเข้าสู่ระบบเพื่อส่งใบสมัคร",
    "volunteer.submitFailed": "ไม่สามารถส่งใบสมัครได้ กรุณาลองอีกครั้ง",

    // Volunteer - ApplicationForm
    "volunteer.applyForTitle": "สมัครสำหรับ: {{title}}",
    "volunteer.fullName": "ชื่อเต็ม *",
    "volunteer.phoneRequired": "หมายเลขโทรศัพท์ *",
    "volunteer.emailRequired": "ที่อยู่อีเมล *",
    "volunteer.dateOfBirth": "วันเกิด",
    "volunteer.availabilityTitle": "ความพร้อม",
    "volunteer.preferredDays": "วันที่ต้องการ",
    "volunteer.preferredTimes": "เวลาที่ต้องการ",
    "volunteer.commitmentLevelLabel": "ระดับความมุ่งมั่น",
    "volunteer.skillsAndExperience": "ทักษะและประสบการณ์",
    "volunteer.relevantExperience": "ประสบการณ์ที่เกี่ยวข้อง *",
    "volunteer.certifications": "ใบรับรอง (คั่นด้วยเครื่องหมายจุลภาค)",
    "volunteer.interestsAndPreferences": "ความสนใจและความชอบ",
    "volunteer.areasOfInterest": "ด้านที่สนใจ (คั่นด้วยเครื่องหมายจุลภาค)",
    "volunteer.referencesTitle": "บุคคลอ้างอิง",
    "volunteer.referenceName": "ชื่อบุคคลอ้างอิง {{index}}",
    "volunteer.referenceContact": "ข้อมูลติดต่อบุคคลอ้างอิง {{index}}",
    "volunteer.workSamplesTitle": "ตัวอย่างผลงาน",
    "volunteer.workSamplesLabel":
      "ลิงก์ตัวอย่างผลงาน (คั่นด้วยเครื่องหมายจุลภาค)",
    "volunteer.submitApplicationShort": "ส่งใบสมัคร",
    "volunteer.validation.nameInvalid":
      "กรุณากรอกชื่อที่ถูกต้อง (2-100 ตัวอักษร)",
    "volunteer.validation.provideExperience":
      "กรุณาให้ข้อมูลเกี่ยวกับประสบการณ์ของคุณ",
    "volunteer.validation.selectDay": "กรุณาเลือกวันอย่างน้อยหนึ่งวัน",
    "volunteer.validation.selectTime": "กรุณาเลือกเวลาอย่างน้อยหนึ่งช่วง",

    // Volunteer - ConsentForm
    "volunteer.consentUnderstand": "ข้าพเจ้าเข้าใจว่า:",
    "volunteer.processingAckTitle": "การรับทราบการประมวลผล",
    "volunteer.processingAckDesc":
      "กรุณาตรวจสอบและรับทราบสิ่งต่อไปนี้ก่อนดำเนินการต่อ:",
    "volunteer.essentialProcessingTitle": "การประมวลผลใบสมัคร (ต้องยืนยัน):",
    "volunteer.acknowledgmentTitle": "การรับทราบ",
    "volunteer.ageConfirmationTitle": "การยืนยันอายุ:",
    "volunteer.privacyNoticeTitle": "ประกาศความเป็นส่วนตัว:",
    "volunteer.doNotAccept": "ไม่ยอมรับ",
    "volunteer.acceptAndContinue": "ยอมรับและดำเนินการต่อ",
    "volunteer.validation.essentialRequired":
      "คุณต้องยืนยันการรับทราบการประมวลผลใบสมัครเพื่อดำเนินการต่อ",
    "volunteer.validation.agePrivacyRequired":
      "คุณต้องยืนยันอายุและว่าคุณได้อ่านประกาศความเป็นส่วนตัวแล้ว",

    // Age affirmation gate (shared across all surfaces — GIV-453)
    "ageGate.positive": "ข้าพเจ้ายืนยันว่ามีอายุ 16 ปีขึ้นไป",
    "ageGate.negative":
      "Give Protocol ให้บริการสำหรับผู้ใช้ที่มีอายุ 16 ปีขึ้นไป หากคุณอายุต่ำกว่า 16 ปี เราไม่สามารถดำเนินการตามคำขอของคุณได้ในขณะนี้",

    // Languages
    "language.english": "อังกฤษ",
    "language.spanish": "สเปน",
    "language.german": "เยอรมัน",
    "language.french": "ฝรั่งเศส",
    "language.japanese": "ญี่ปุ่น",
    "language.chinese_simplified": "จีน (ตัวย่อ)",
    "language.chinese_traditional": "จีน (ตัวเต็ม)",
    "language.thai": "ไทย",
    "language.vietnamese": "เวียดนาม",
    "language.korean": "เกาหลี",
    "language.arabic": "อาหรับ",
    "language.hindi": "ฮินดี",
    "language.multiple": "หลายภาษา",

    // Contribution types
    "contribution.type.donation": "การบริจาค",
    "contribution.type.volunteerapplication": "การสมัครอาสาสมัคร",
    "contribution.type.volunteerhours": "ชั่วโมงอาสาสมัคร",
    "contribution.type.volunteeracceptance": "การยอมรับอาสาสมัคร",
    "contribution.type.volunteerverification": "การตรวจสอบอาสาสมัคร",

    // Donor/Volunteer
    "donor.volunteer": "ผู้บริจาค/อาสาสมัคร",
    "donor.anonymous": "ไม่ระบุชื่อ",
    "volunteer.unknown": "อาสาสมัครที่ไม่ทราบ",

    // Statuses
    "status.completed": "เสร็จสิ้น",
    "status.pending": "รอดำเนินการ",
    "status.failed": "ล้มเหลว",

    // Blockchain
    "blockchain.block": "บล็อก",

    // Filter
    "filter.allYears": "ทุกปี",
    "filter.allTypes": "ทุกประเภท",
    "filter.donations": "การบริจาค",
    "filter.volunteerApplications": "การสมัครอาสาสมัคร",
    "filter.volunteerHours": "ชั่วโมงอาสาสมัคร",
    "filter.fiatDonations": "การบริจาคสกุลเงินปกติ",

    // Export
    "export.title": "ส่งออกข้อมูลการมีส่วนร่วม",
    "export.filename": "ชื่อไฟล์",
    "export.dateRange": "ช่วงวันที่",
    "export.includePersonal": "รวมที่อยู่กระเป๋าเงิน",
    "export.willInclude": "การส่งออกจะรวมถึง:",
    "export.walletAddresses": "ที่อยู่กระเป๋าเงิน (ผู้ส่งและผู้รับ)",
    "export.volunteerDetails": "รายละเอียดการมีส่วนร่วมของอาสาสมัคร (เมื่อมี)",
    "export.verificationHashes": "แฮชการตรวจสอบ (เมื่อมี)",
    "export.cancel": "ยกเลิก",
    "export.download": "ส่งออก CSV",

    // Skills
    "skills.endorsements": "ทักษะและการรับรอง",

    // Home
    "home.subtitle": "เชื่อมโยงทรัพยากรกับสาเหตุที่ต้องการมากที่สุด",
    "home.startDonating": "เริ่มบริจาค",

    // Modal - shared
    "modal.close": "ปิดหน้าต่าง",
    "modal.closeAriaLabel": "ปิด",

    // Modal - wallet connection
    "modal.wallet.title": "เชื่อมต่อกระเป๋าเงินของคุณ",
    "modal.wallet.description":
      "เชื่อมต่อกระเป๋าเงินเพื่อปลดล็อกคุณสมบัติทั้งหมดของ Give Protocol",
    "modal.wallet.benefit1": "ติดตามการบริจาคของคุณอย่างโปร่งใสบนบล็อกเชน",
    "modal.wallet.benefit2":
      "รับโทเคน GIVE เป็นรางวัลสำหรับการมีส่วนร่วมของคุณ",
    "modal.wallet.benefit3":
      "มีส่วนร่วมในการตัดสินใจด้านการกำกับดูแลของโปรโตคอล",
    "modal.wallet.connecting": "กำลังเชื่อมต่อ...",
    "modal.wallet.clickToConnect": "คลิกเพื่อเชื่อมต่อ",
    "modal.wallet.noExtension": "ไม่พบส่วนขยายกระเป๋าเงิน",
    "modal.wallet.installMetaMask": "ติดตั้ง MetaMask เพื่อเริ่มต้น",
    "modal.wallet.skip": "ข้ามไปก่อน",
    "modal.wallet.footerNote":
      "คุณสามารถเชื่อมต่อกระเป๋าเงินได้ทุกเมื่อจากแถบนำทาง",
    "modal.wallet.failedConnect": "ไม่สามารถเชื่อมต่อกระเป๋าเงินได้",

    // Modal - wallet link
    "modal.walletLink.title": "เชื่อมโยงกระเป๋าเงินของคุณ",
    "modal.walletLink.description":
      "เชื่อมโยงกระเป๋าเงินกับบัญชีของคุณเพื่อการบริจาคบนเชน รางวัลโทเคน และการกำกับดูแล",
    "modal.walletLink.benefit1":
      "บริจาคคริปโตโดยตรงให้กับองค์กรการกุศลที่ผ่านการตรวจสอบบนเชน",
    "modal.walletLink.benefit2Pre": "พัฒนา",
    "modal.walletLink.benefit2Post": "ข้อมูลประจำตัวสำหรับการมีส่วนร่วมของคุณ",
    "modal.walletLink.benefit3":
      "เข้าสู่ระบบด้วยอีเมลหรือกระเป๋าเงิน \u2014 บัญชีเดียวกัน",
    "modal.walletLink.buttonLinking": "กำลังเชื่อมโยง\u2026",
    "modal.walletLink.buttonLink": "เชื่อมโยงกระเป๋าเงิน",
    "modal.walletLink.buttonConnectFirst": "เชื่อมต่อกระเป๋าเงินก่อน",
    "modal.walletLink.footerNote":
      "คุณสามารถเชื่อมโยงกระเป๋าเงินได้ทุกเมื่อจากการตั้งค่า",
    "modal.walletLink.failedLink": "ไม่สามารถเชื่อมโยงกระเป๋าเงินได้",

    // Modal - chain selection
    "modal.chain.title": "ยินดีต้อนรับสู่ Give Protocol",
    "modal.chain.subtitle": "เลือกเครือข่ายที่ต้องการเพื่อเริ่มต้น",
    "modal.chain.footerNote": "คุณสามารถเปลี่ยนเครือข่ายได้ทุกเมื่อจากเมนู",
    "modal.chain.connecting": "กำลังเชื่อมต่อ...",
    "modal.chain.continue": "ดำเนินการต่อ",
    "modal.chain.failedSelect": "ไม่สามารถเลือกเครือข่ายได้",

    // Modal - network selection (WalletModal step 1)
    "modal.network.title": "เลือกเครือข่าย",
    "modal.network.nextStep": "ขั้นตอนถัดไป: เชื่อมต่อกระเป๋าเงิน",
    "modal.network.learnMore": "เรียนรู้เพิ่มเติมเกี่ยวกับการเลือกเครือข่าย",

    // Modal - wallet connect (WalletModal step 2)
    "modal.connect.title": "เชื่อมต่อกระเป๋าเงิน",
    "modal.connect.backAria": "กลับไปยังการเลือกเครือข่าย",
    "modal.connect.noWallets": "ไม่มีกระเป๋าเงินสำหรับเชน {{chainType}}",
    "modal.connect.tryDifferentChain": "ลองเลือกประเภทเชนอื่น",
    "modal.connect.viewOtherWallets": "ดูกระเป๋าเงินอื่นที่รองรับ",
    "modal.connect.termsAgreement": "การเชื่อมต่อแสดงว่าคุณยอมรับ",
    "modal.connect.termsLink": "ข้อกำหนดการใช้บริการ",
    "modal.connect.termsPrivacyConnector": "และ",
    "modal.connect.privacyLink": "นโยบายความเป็นส่วนตัว",
    "modal.connect.chainTypeAria": "ประเภทเชน",
    "modal.connect.failedConnect": "การเชื่อมต่อล้มเหลว",

    // Modal - donation
    "modal.donation.successTitle": "ขอบคุณ!",
    "modal.donation.donationProcessedOneTime":
      "การบริจาคของคุณจำนวน {{amount}} ให้กับ {{charityName}} ได้รับการดำเนินการแล้ว",
    "modal.donation.donationProcessedRecurring":
      "การบริจาครายเดือนของคุณจำนวน {{amount}} ให้กับ {{charityName}} ได้รับการดำเนินการแล้ว",
    "modal.donation.recurringNote":
      "คุณจะถูกเรียกเก็บเงินรายเดือนจนกว่าจะยกเลิก",
    "modal.donation.receiptNote": "ใบเสร็จรับเงินได้ถูกส่งไปยังอีเมลของคุณแล้ว",
    "modal.donation.done": "เสร็จสิ้น",
    "modal.donation.errorTitle": "เกิดข้อผิดพลาด",
    "modal.donation.errorDefault":
      "เกิดข้อผิดพลาดที่ไม่คาดคิด กรุณาลองอีกครั้ง",
    "modal.donation.tryAgain": "ลองอีกครั้ง",
    "modal.donation.close": "ปิด",
    "modal.donation.amountLabel": "จำนวนเงินบริจาค",
    "modal.donation.perMonth": "ต่อเดือน",
    "modal.donation.monthly": "รายเดือน",
    "modal.donation.oneTime": "ครั้งเดียว",
    "modal.donation.loadingPaymentForm": "กำลังโหลดแบบฟอร์มการชำระเงิน...",
    "modal.donation.supportMonthly": "สนับสนุน {{charityName}} รายเดือน",
    "modal.donation.donateToCharity": "บริจาคให้ {{charityName}}",

    // Modal - scheduled donation
    "modal.scheduledDonation.title":
      "ตั้งเวลาบริจาครายเดือนให้ {{charityName}}",

    // Modal - withdrawal
    "modal.withdrawal.title": "ขอถอนเงิน",

    // Modal - validation response
    "modal.validation.rejectTitle": "ปฏิเสธคำขอการรับรอง",
    "modal.validation.reviewTitle": "ตรวจสอบคำขอการรับรอง",
    "modal.validation.volunteer": "อาสาสมัคร",
    "modal.validation.activityDetails": "รายละเอียดกิจกรรม",
    "modal.validation.date": "วันที่",
    "modal.validation.hour": "ชั่วโมง",
    "modal.validation.hours": "ชั่วโมง",
    "modal.validation.activityType": "ประเภทกิจกรรม",
    "modal.validation.location": "สถานที่",
    "modal.validation.description": "คำอธิบาย",
    "modal.validation.submitted": "ส่งเมื่อ:",
    "modal.validation.daysRemaining": "(เหลืออีก {{count}} วันในการรับรอง)",
    "modal.validation.appealNote":
      "นี่คือการอุทธรณ์/การส่งซ้ำของคำขอที่เคยถูกปฏิเสธ",
    "modal.validation.rejectPrompt":
      "กรุณาเลือกเหตุผลในการปฏิเสธคำขอการรับรองนี้ อาสาสมัครจะได้รับการแจ้งเตือน",
    "modal.validation.reject": "ปฏิเสธ",
    "modal.validation.approve": "อนุมัติ",
    "modal.validation.processing": "กำลังดำเนินการ...",
    "modal.validation.back": "ย้อนกลับ",
    "modal.validation.confirmRejection": "ยืนยันการปฏิเสธ",
    "modal.validation.selectReasonError": "กรุณาเลือกเหตุผลในการปฏิเสธ",

    // Toast
    "toast.dismiss": "ปิดการแจ้งเตือน",

    // Error boundary
    "error.somethingWrong": "เกิดข้อผิดพลาด",
    "error.unexpectedError": "เกิดข้อผิดพลาดที่ไม่คาดคิด",
    "error.tryAgain": "ลองอีกครั้ง",
    "error.tooManyAttempts": "มีการพยายามมากเกินไป",
    "error.goHome": "ไปยังหน้าหลัก",
    "error.details": "รายละเอียดข้อผิดพลาด",

    // Validation - rejection reason select
    "validation.rejection.reasonLabel": "เหตุผลในการปฏิเสธ",
    "validation.rejection.reasonPlaceholder": "เลือกเหตุผล...",
    "validation.rejection.notesLabel": "หมายเหตุเพิ่มเติม",
    "validation.rejection.optional": "(ไม่บังคับ)",
    "validation.rejection.notesPlaceholder":
      "ให้บริบทเพิ่มเติมสำหรับการปฏิเสธ...",

    // Validation - batch actions
    "validation.batch.deselectAll": "ยกเลิกการเลือกทั้งหมด",
    "validation.batch.selectAll": "เลือกทั้งหมด",
    "validation.batch.selected": "เลือก {{selected}} จาก {{total}} รายการ",
    "validation.batch.clear": "ล้าง",
    "validation.batch.reject": "ปฏิเสธ ({{count}})",
    "validation.batch.approve": "อนุมัติ ({{count}})",

    // Dashboard - admin redirect (GIV-254)
    "dashboard.adminTitle": "แดชบอร์ดผู้ดูแลระบบ",
    "dashboard.adminNote": "กรุณาใช้แผงผู้ดูแลระบบเพื่อจัดการแพลตฟอร์ม",
    "dashboard.adminButton": "ไปยังแผงผู้ดูแลระบบ",
    "dashboard.logVolunteerHours": "บันทึกชั่วโมงอาสาสมัคร",
    "dashboard.hideVolunteerHours": "ซ่อนชั่วโมงอาสาสมัคร",
    "dashboard.viewMonthlyDonations": "ดูการบริจาครายเดือน",
    "dashboard.hideMonthlyDonations": "ซ่อนการบริจาครายเดือน",
    "dashboard.walletSettings": "การตั้งค่ากระเป๋าเงิน",
    "dashboard.overview": "ภาพรวม",
    "dashboard.lastUpdated": "อัปเดตล่าสุด",
    "dashboard.refreshData": "รีเฟรชข้อมูล",
    "dashboard.searchPlaceholder": "ค้นหาโครงการ, อาสาสมัคร (Cmd+K)",
    "dashboard.search": "ค้นหา",

    // Settings - account section (GIV-254)
    "settings.manageDescription": "จัดการบัญชีและการตั้งค่าของคุณ",
    "settings.account": "บัญชี",
    "settings.email": "อีเมล",
    "settings.displayName": "ชื่อที่แสดง",
    "settings.authMethod": "วิธีการยืนยันตัวตน",
    "settings.role": "บทบาท",

    // Common additional (GIV-254)
    "common.refresh": "รีเฟรช",
    "common.all": "ทั้งหมด",
    "common.loading": "กำลังโหลด...",
    "common.close": "ปิด",
    "common.back": "ย้อนกลับ",

    // Cause (GIV-254)
    "cause.createCause": "สร้างสาเหตุ",

    // Contribution Tracker (GIV-254)
    "tracker.title": "การจัดอันดับผลกระทบระดับโลก",
    "tracker.subtitle": "ติดตามและเฉลิมฉลองผลกระทบโดยรวมของชุมชนของเรา",
    "tracker.searchPlaceholder": "ค้นหาผู้มีส่วนร่วม...",
    "tracker.exportCSV": "ส่งออก CSV",
    "tracker.exportPDF": "ส่งออก PDF",
    "tracker.hideContributions": "ซ่อนการมีส่วนร่วมของฉันจากการจัดอันดับ",
    "tracker.yourAlias": "ชื่อเล่นของคุณ:",
    "tracker.changeAlias": "เปลี่ยน",
    "tracker.setWalletAlias": "ตั้งชื่อเล่นกระเป๋าเงิน",
    "tracker.aliasTitle": "ตั้งชื่อเล่นกระเป๋าเงิน",
    "tracker.aliasDescription":
      "ชื่อเล่นของคุณจะแสดงบนตัวติดตามการมีส่วนร่วมแทนที่อยู่กระเป๋าเงินของคุณ",
    "tracker.aliasLabel": "ชื่อเล่น",
    "tracker.aliasPlaceholder": "กรอกชื่อเล่นที่ต้องการ",
    "tracker.saveAlias": "บันทึกชื่อเล่น",
    "tracker.donationRankings": "การจัดอันดับการบริจาค",
    "tracker.volunteerRankings": "การจัดอันดับอาสาสมัคร",
    "tracker.exportComplete": "ส่งออกเรียบร้อย",
    "tracker.exportDonationCSV": "ส่งออกตารางอันดับการบริจาคเป็น CSV แล้ว",
    "tracker.exportVolunteerCSV": "ส่งออกตารางอันดับอาสาสมัครเป็น CSV แล้ว",
    "tracker.exportPDFSuccess": "ส่งออกตารางอันดับเป็น PDF แล้ว",
    "tracker.exportFailed": "การส่งออกล้มเหลว",
    "tracker.exportNoData": "ไม่มีข้อมูลสำหรับส่งออก",
    "tracker.exportError": "เกิดข้อผิดพลาดขณะส่งออกข้อมูล",
    "tracker.walletNotConnected": "ไม่ได้เชื่อมต่อกระเป๋าเงิน",
    "tracker.connectWalletForAlias":
      "กรุณาเชื่อมต่อกระเป๋าเงินเพื่อตั้งชื่อเล่น",
    "tracker.invalidAlias": "ชื่อเล่นไม่ถูกต้อง",
    "tracker.enterValidAlias": "กรุณากรอกชื่อเล่นที่ถูกต้อง",

    // Charity Portal (GIV-254)
    "charity.portal.deleteTitle": "ลบ {{type}}?",
    "charity.portal.deleteDescription":
      "การดำเนินการนี้ไม่สามารถย้อนกลับได้ {{type}} จะถูกลบอย่างถาวร",
    "charity.portal.walletNotConfigured": "ยังไม่ได้กำหนดค่ากระเป๋าเงินรับเงิน",
    "charity.portal.walletDonationNote":
      "เชื่อมต่อกระเป๋าเงินเพื่อรับการบริจาคบนเชน",
    "charity.portal.setupWallet": "ตั้งค่ากระเป๋าเงิน",

    // Charity dashboard onboarding & verification
    "charity.onboarding.ariaLabel": "รายการตรวจสอบการเริ่มต้นใช้งาน",
    "charity.onboarding.title": "เริ่มต้นใช้งาน",
    "charity.onboarding.progress":
      "เสร็จสิ้น {{completed}} จาก {{total}} ขั้นตอน",
    "charity.onboarding.optional": "ไม่บังคับ",
    "charity.onboarding.allComplete":
      "เสร็จสิ้นทุกขั้นตอนแล้ว! คุณสามารถปิดรายการนี้ได้",
    "charity.onboarding.expand": "ขยายรายการตรวจสอบ",
    "charity.onboarding.collapse": "ย่อรายการตรวจสอบ",
    "charity.onboarding.dismiss": "ปิดรายการตรวจสอบการเริ่มต้นใช้งาน",
    "charity.onboarding.check": "ทำเครื่องหมาย {{label}}",
    "charity.onboarding.uncheck": "ยกเลิกเครื่องหมาย {{label}}",
    "charity.onboarding.stepDone": "{{label}} (เสร็จสิ้น)",
    "charity.onboarding.stepAuto": "{{label}} (เสร็จสิ้นโดยอัตโนมัติ)",
    "charity.onboarding.goToOrganization": "ไปที่องค์กร",
    "charity.onboarding.setupWallet": "ตั้งค่ากระเป๋าเงิน",
    "charity.onboarding.item.completeProfile.label":
      "กรอกโปรไฟล์องค์กรให้สมบูรณ์",
    "charity.onboarding.item.completeProfile.description":
      "เพิ่มชื่อองค์กร คำอธิบาย ที่อยู่ และข้อมูลติดต่อ",
    "charity.onboarding.item.uploadLogo.label": "อัปโหลดโลโก้หรือภาพแบนเนอร์",
    "charity.onboarding.item.uploadLogo.description":
      "เพิ่มโลโก้หรือแบนเนอร์เพื่อช่วยให้ผู้บริจาคจดจำองค์กรการกุศลของคุณ",
    "charity.onboarding.item.connectWallet.label":
      "ตั้งค่ากระเป๋าเงินรับบริจาค",
    "charity.onboarding.item.connectWallet.description":
      "เลือก Safe แบบหลายลายเซ็น การดูแลสินทรัพย์ระดับสถาบัน หรือกระเป๋าเงินแบบลายเซ็นเดียวเพื่อรับเงินบริจาค และพิสูจน์การควบคุมด้วยการลงนามข้อความ",
    "charity.onboarding.item.bankDetails.label":
      "ตั้งค่าข้อมูลธนาคารสำหรับการแปลงเป็นเงินสกุลท้องถิ่น",
    "charity.onboarding.item.bankDetails.description":
      "ตั้งค่าข้อมูลธนาคารหากต้องการรับเงินบริจาคผ่านบัตร",
    "charity.onboarding.item.acceptTerms.label":
      "ตรวจสอบและยอมรับข้อกำหนดการให้บริการ",
    "charity.onboarding.item.acceptTerms.description":
      "อ่านและยืนยันข้อกำหนดและเงื่อนไขของ Give Protocol สำหรับองค์กรการกุศล",
    "charity.verification.pendingTitle": "ใบสมัครอยู่ระหว่างการตรวจสอบ",
    "charity.verification.pendingBody":
      "ทีมงานกำลังตรวจสอบใบสมัครองค์กรการกุศลของคุณ โดยปกติใช้เวลา 3–5 วันทำการ เราจะส่งอีเมลแจ้งเมื่อมีการตัดสินใจ",
    "charity.verification.rejectedTitle": "ใบสมัครไม่ได้รับการอนุมัติ",
    "charity.verification.reason": "เหตุผล: {{notes}}",
    "charity.verification.rejectedDefault":
      "ใบสมัครของคุณไม่ได้รับการอนุมัติในขณะนี้",
    "charity.verification.contactSupport": "ติดต่อฝ่ายสนับสนุน",
    "charity.verification.suspendedTitle": "บัญชีถูกระงับ",
    "charity.verification.suspendedDefault": "บัญชีองค์กรการกุศลของคุณถูกระงับ",
    "charity.verification.appealSuspension": "อุทธรณ์การระงับ",
    "charity.verification.verifiedTitle": "องค์กรการกุศลได้รับการยืนยันแล้ว",
    "charity.verification.verifiedBody":
      "องค์กรของคุณได้รับการยืนยันแล้ว ผู้บริจาคสามารถสนับสนุนโครงการของคุณได้แล้ว",
    "charity.portal.receivingWallet": "กระเป๋าเงินรับบริจาค: {{address}}",
    "charity.portal.loadError":
      "ไม่สามารถโหลดข้อมูลองค์กรการกุศลได้ กรุณาลองอีกครั้ง",

    // Timestamps (GIV-254)
    "timestamp.justNow": "เมื่อสักครู่",
    "timestamp.oneMinuteAgo": "1 นาทีที่แล้ว",
    "timestamp.minutesAgo": "{{count}} นาทีที่แล้ว",

    // Common additions (GIV-256)
    "common.previous": "ก่อนหน้า",
    "common.next": "ถัดไป",
    "common.pageOfTotal": "หน้า {{page}} จาก {{total}}",
    "common.retry": "ลองใหม่",
    "common.processing": "กำลังดำเนินการ...",
    "common.saving": "กำลังบันทึก...",
    "common.donate": "บริจาค",
    "common.active": "ใช้งานอยู่",

    // Portfolio Funds - public page (GIV-256)
    "portfolio.donationType": "ประเภทการบริจาค",
    "portfolio.devNative": "DEV (เนทีฟ)",
    "portfolio.testToken": "โทเคน TEST",
    "portfolio.donationAmount": "จำนวนเงินบริจาค:",
    "portfolio.platformFee": "ค่าธรรมเนียมแพลตฟอร์ม ({{percentage}}%):",
    "portfolio.toCharities": "ไปยังองค์กรการกุศล:",
    "portfolio.eachCharityReceives": "แต่ละองค์กรการกุศลจะได้รับ:",
    "portfolio.donateToFund": "บริจาคให้ {{name}}",
    "portfolio.equalDistribution": "การกระจายเท่าเทียมกัน",
    "portfolio.equalDistributionNote":
      "การบริจาคของคุณจะถูกแบ่งเท่าเทียมกันระหว่างองค์กรการกุศลที่ผ่านการตรวจสอบ {{count}} แห่ง",
    "portfolio.eachCharityPercentage":
      "แต่ละองค์กรการกุศลจะได้รับ {{percentage}}% ของการบริจาค",
    "portfolio.verifiedCharities":
      "องค์กรการกุศลที่ผ่านการตรวจสอบ {{count}} แห่ง",
    "portfolio.donateToFundButton": "บริจาคให้กองทุน",
    "portfolio.noFundsAvailable": "ไม่มีกองทุนพอร์ตโฟลิโอที่พร้อมใช้งาน",
    "portfolio.checkBackLater":
      "กลับมาตรวจสอบในภายหลังสำหรับโอกาสการระดมทุนใหม่",
    "portfolio.amountLabel": "จำนวน ({{currency}})",
    "portfolio.invalidAmount": "กรุณากรอกจำนวนที่ถูกต้อง",
    "portfolio.donationSuccess": "บริจาคสำเร็จ!",
    "portfolio.donationFailed": "การบริจาคล้มเหลว กรุณาลองอีกครั้ง",

    // Admin - Activity event type labels (GIV-256)
    "admin.activity.donation": "การบริจาค",
    "admin.activity.registration": "การลงทะเบียน",
    "admin.activity.verification": "การตรวจสอบ",
    "admin.activity.volunteerHours": "ชั่วโมงอาสาสมัคร",
    "admin.activity.default": "กิจกรรม",

    // Admin - Dashboard page (GIV-256)
    "admin.dashboard.title": "แดชบอร์ดผู้ดูแลระบบ",
    "admin.dashboard.alerts": "การแจ้งเตือน",
    "admin.dashboard.alertsPending": "{{count}} รายการที่รอดำเนินการ",
    "admin.dashboard.alertsView": "ดู",
    "admin.dashboard.recentActivity": "กิจกรรมล่าสุด",
    "admin.dashboard.noRecentActivity": "ไม่มีกิจกรรมล่าสุด",
    "admin.dashboard.quickActions": "การดำเนินการด่วน",
    "admin.dashboard.errorTitle": "ข้อผิดพลาดในการโหลดแดชบอร์ด",
    "admin.stats.last7d": "7 วันที่ผ่านมา",
    "admin.stats.last30d": "30 วันที่ผ่านมา",
    "admin.stats.totalDonors": "ผู้บริจาคทั้งหมด",
    "admin.stats.newRegistrations": "การลงทะเบียนใหม่",
    "admin.stats.charities": "องค์กรการกุศล",
    "admin.stats.pendingVerification": "รอการตรวจสอบ",
    "admin.stats.verifiedCharities": "องค์กรการกุศลที่ผ่านการตรวจสอบ",
    "admin.stats.activeVolunteers": "อาสาสมัครที่ใช้งานอยู่",
    "admin.stats.totalDonationVolume": "ยอดบริจาครวม",
    "admin.stats.cryptoVolume": "ยอดคริปโต",
    "admin.stats.fiatVolume": "ยอดเงินสด",
    "admin.stats.donations": "การบริจาค",

    // Admin - Quick Actions (GIV-256)
    "admin.actions.viewReports": "ดูรายงาน",
    "admin.actions.viewReportsDesc": "สร้างรายงานวิเคราะห์โดยละเอียด",
    "admin.actions.manageCharities": "จัดการองค์กรการกุศล",
    "admin.actions.manageCharitiesDesc": "ตรวจสอบและอนุมัติองค์กร",
    "admin.actions.systemSettings": "การตั้งค่าระบบ",
    "admin.actions.systemSettingsDesc": "กำหนดค่าพารามิเตอร์แพลตฟอร์ม",
    "admin.actions.manageImpactMetrics": "จัดการตัวชี้วัดผลกระทบ",
    "admin.actions.manageImpactMetricsDesc": "กำหนดค่าข้อมูลตัวคำนวณผลกระทบ",
    "admin.actions.donationMonitoring": "การตรวจสอบการบริจาค",
    "admin.actions.donationMonitoringDesc":
      "ตรวจสอบ ตั้งค่าสถานะ และรายงานการบริจาค",
    "admin.actions.contentModeration": "การกลั่นกรองเนื้อหา",
    "admin.actions.contentModerationDesc":
      "ซ่อน ตั้งค่าสถานะ และตรวจสอบโอกาสและสาเหตุ",
    "admin.actions.portfolioFunds": "กองทุนพอร์ตโฟลิโอ",
    "admin.actions.portfolioFundsDesc":
      "สร้างและจัดการพอร์ตโฟลิโอการให้ที่คัดสรร",
    "admin.actions.charityRequests": "คำขอองค์กรการกุศล",
    "admin.actions.charityRequestsDesc":
      "ตรวจสอบคำขอของผู้บริจาคสำหรับองค์กรการกุศลที่ยังไม่มีผู้อ้างสิทธิ์",

    // Admin - Portfolio Funds management page (GIV-256)
    "admin.portfolio.title": "กองทุนพอร์ตโฟลิโอ",
    "admin.portfolio.subtitle": "สร้างและจัดการพอร์ตโฟลิโอการให้ที่คัดสรร",
    "admin.portfolio.newFund": "กองทุนใหม่",
    "admin.portfolio.editFund": "แก้ไขกองทุน",
    "admin.portfolio.createNewFund": "สร้างกองทุนใหม่",
    "admin.portfolio.fundName": "ชื่อกองทุน",
    "admin.portfolio.fundNamePlaceholder": "เช่น กองทุนผลกระทบสิ่งแวดล้อม",
    "admin.portfolio.description": "คำอธิบาย",
    "admin.portfolio.descriptionPlaceholder":
      "อธิบายวัตถุประสงค์และจุดเน้นด้านผลกระทบของกองทุน...",
    "admin.portfolio.category": "หมวดหมู่",
    "admin.portfolio.selectCategory": "เลือกหมวดหมู่",
    "admin.portfolio.imageUrl": "URL รูปภาพ",
    "admin.portfolio.imageUrlPlaceholder": "https://...",
    "admin.portfolio.selectCharities":
      "เลือกองค์กรการกุศล (เลือกแล้ว {{count}} แห่ง)",
    "admin.portfolio.noCharitiesFound": "ไม่พบองค์กรการกุศลที่ผ่านการตรวจสอบ",
    "admin.portfolio.saving": "กำลังบันทึก...",
    "admin.portfolio.createFund": "สร้างกองทุน",
    "admin.portfolio.updateFund": "อัปเดตกองทุน",
    "admin.portfolio.noFundsYet": "ยังไม่มีกองทุนพอร์ตโฟลิโอ",
    "admin.portfolio.noFundsMessage":
      "สร้างกองทุนแรกของคุณเพื่อจัดกลุ่มองค์กรการกุศลสำหรับการบริจาครวม",
    "admin.portfolio.charity": "องค์กรการกุศล",
    "admin.portfolio.charities": "องค์กรการกุศล",
    "admin.portfolio.createdOn": "สร้างเมื่อ {{date}}",
    "admin.portfolio.statusActive": "ใช้งานอยู่",
    "admin.portfolio.statusPaused": "หยุดชั่วคราว",
    "admin.portfolio.statusArchived": "เก็บถาวร",
    "admin.portfolio.errorLoad": "ไม่สามารถโหลดข้อมูลได้",
    "admin.portfolio.errorArchive": "ไม่สามารถเก็บถาวรกองทุนได้",
    "admin.portfolio.fundArchived": "เก็บถาวรกองทุนแล้ว",
    "admin.portfolio.fundUpdated": "อัปเดตกองทุนแล้ว",
    "admin.portfolio.fundCreated": "สร้างกองทุนแล้ว",
    "admin.portfolio.errorSave": "ไม่สามารถบันทึกกองทุนได้",

    // Admin - Charity Management page (GIV-256)
    "admin.charity.title": "การจัดการองค์กรการกุศล",
    "admin.charity.totalCount": "ทั้งหมด {{count}} แห่ง",
    "admin.charity.allStatuses": "ทุกสถานะ",
    "admin.charity.searchPlaceholder": "ค้นหาตามชื่อ\u2026",
    "admin.charity.colName": "ชื่อ",
    "admin.charity.colEin": "เลขประจำตัวผู้เสียภาษี",
    "admin.charity.taxIdDisplay": "เลขประจำตัวผู้เสียภาษี {{value}}",
    "admin.charity.searchByNameEin": "ค้นหาตามชื่อหรือเลขประจำตัวผู้เสียภาษี…",
    "admin.charity.colCategory": "หมวดหมู่",
    "admin.charity.colStatus": "สถานะ",
    "admin.charity.colSigner": "ผู้ติดต่อ",
    "admin.charity.colJoined": "เข้าร่วมเมื่อ",
    "admin.charity.colWallet": "กระเป๋าเงิน",
    "admin.charity.colActions": "การดำเนินการ",
    "admin.charity.walletNotSet": "ยังไม่ตั้งค่า",
    "admin.charity.approve": "อนุมัติ",
    "admin.charity.reject": "ปฏิเสธ",
    "admin.charity.suspend": "ระงับ",
    "admin.charity.reinstate": "คืนสถานะ",
    "admin.charity.statusPending": "รอดำเนินการ",
    "admin.charity.statusVerified": "ผ่านการตรวจสอบ",
    "admin.charity.statusApproved": "อนุมัติแล้ว",
    "admin.charity.statusRejected": "ถูกปฏิเสธ",
    "admin.charity.statusSuspended": "ถูกระงับ",
    "admin.charity.approveTitle": "อนุมัติองค์กรการกุศล",
    "admin.charity.rejectTitle": "ปฏิเสธองค์กรการกุศล",
    "admin.charity.suspendTitle": "ระงับองค์กรการกุศล",
    "admin.charity.reinstateTitle": "คืนสถานะองค์กรการกุศล",
    "admin.charity.confirmAction": "ยืนยันการดำเนินการ",
    "admin.charity.reasonRequired": "เหตุผล (จำเป็น)",
    "admin.charity.reasonOptional": "เหตุผล (ไม่บังคับ)",
    "admin.charity.saving": "กำลังบันทึก\u2026",
    "admin.charity.confirm": "ยืนยัน",
    "admin.charity.noResults": "ไม่พบองค์กรการกุศลที่ตรงกับตัวกรองของคุณ",
    "admin.charity.unnamed": "องค์กรที่ไม่มีชื่อ",

    // Admin - Charity Requests page (GIV-256)
    "admin.charityRequests.title": "คำขอองค์กรการกุศล",
    "admin.charityRequests.subtitle":
      "คำขอจากผู้บริจาคสำหรับองค์กรการกุศลที่ยังไม่มีผู้อ้างสิทธิ์ จัดกลุ่มตามองค์กร องค์กรที่มีความสนใจสูงสุดควรได้รับความสำคัญในการติดต่อ",
    "admin.charityRequests.ein": "เลขประจำตัวผู้เสียภาษี",
    "admin.charityRequests.requests": "คำขอ",
    "admin.charityRequests.latestRequester": "ผู้ร้องขอล่าสุด",
    "admin.charityRequests.latestRequest": "คำขอล่าสุด",
    "admin.charityRequests.firstRequest": "คำขอแรก",
    "admin.charityRequests.empty": "ยังไม่มีคำขอองค์กรการกุศลที่ส่งเข้ามา",
    "admin.charityRequests.errorTitle": "ข้อผิดพลาดในการโหลดคำขอองค์กรการกุศล",
    "admin.charityRequests.showing":
      "แสดง {{shown}} จาก {{total}} องค์กรที่ไม่ซ้ำกัน",

    // Admin - Volunteer Validation page (GIV-256)
    "admin.validation.title": "การกำกับดูแลการรับรองอาสาสมัคร",
    "admin.validation.totalCount": "คำขอทั้งหมด {{count}} รายการ",
    "admin.validation.pipelineStats": "สถิติกระบวนการ",
    "admin.validation.noStats": "ไม่มีสถิติที่พร้อมใช้งาน",
    "admin.validation.pending": "รอดำเนินการ",
    "admin.validation.approved": "อนุมัติแล้ว",
    "admin.validation.rejected": "ถูกปฏิเสธ",
    "admin.validation.expired": "หมดอายุ",
    "admin.validation.avgResponseTime": "เวลาตอบสนองเฉลี่ย:",
    "admin.validation.expirationRate": "อัตราการหมดอายุ:",
    "admin.validation.rejectionRate": "อัตราการปฏิเสธ:",
    "admin.validation.searchPlaceholder": "ค้นหาอาสาสมัคร, องค์กร\u2026",
    "admin.validation.requestsTab": "คำขอการรับรอง",
    "admin.validation.patternsTab": "รูปแบบที่น่าสงสัย",
    "admin.validation.colVolunteer": "อาสาสมัคร",
    "admin.validation.colOrganisation": "องค์กร",
    "admin.validation.colHours": "ชั่วโมง",
    "admin.validation.colActivityDate": "วันที่ทำกิจกรรม",
    "admin.validation.colHrsPerWeek": "ชม./สัปดาห์",
    "admin.validation.colTotalRequests": "คำขอทั้งหมด",
    "admin.validation.override": "แทนที่",
    "admin.validation.noPatterns": "ไม่พบรูปแบบที่น่าสงสัย",
    "admin.validation.noRequests": "ไม่พบคำขอการรับรอง",
    "admin.validation.patternsDescription":
      "อาสาสมัครที่ถูกตั้งค่าสถานะเนื่องจากรายงานชั่วโมงเกินกว่าเกณฑ์ที่กำหนดในหน้าต่าง 7 วัน รูปแบบเหล่านี้อาจบ่งชี้การใช้งานระบบชั่วโมงที่รายงานด้วยตนเองอย่างไม่เหมาะสม",
    "admin.validation.overrideTitle": "แทนที่คำขอการรับรอง",
    "admin.validation.newStatus": "สถานะใหม่",
    "admin.validation.reasonRequired": "เหตุผล (จำเป็น)",
    "admin.validation.reasonPlaceholder":
      "อธิบายเหตุผลในการแทนที่คำขอนี้\u2026",
    "admin.validation.saving": "กำลังบันทึก\u2026",
    "admin.validation.confirmOverride": "ยืนยันการแทนที่",
    "admin.validation.allStatuses": "ทุกสถานะ",
    "admin.validation.colStatus": "สถานะ",
    "admin.validation.colCreated": "สร้างเมื่อ",

    // GIV-266: Delta translations (354 keys)
    "home.hero.title": "การให้ที่โปร่งใส",
    "home.hero.titleAccent": "ผลกระทบที่ยั่งยืน",
    "home.hero.description":
      "การกุศลที่โปร่งใสอย่างแท้จริงสำหรับยุคดิจิทัล สร้างขึ้นเพื่อสร้างผลกระทบ รองรับด้วยเทคโนโลยีที่ตรวจสอบได้ ทุกการบริจาคสามารถติดตามได้ตั้งแต่ผู้บริจาคถึงปลายทาง",
    "home.hero.visionTitle": "วิสัยทัศน์ของเรา",
    "home.hero.visionText":
      "Give Protocol กำลังออกแบบอนาคตของการให้ที่มีความน่าเชื่อถือสูง เราใช้ประโยชน์จากโครงสร้างพื้นฐานเทคโนโลยีขั้นสูงเพื่อเชื่อมช่องว่างระหว่างทุนระดับโลกและผลกระทบระดับท้องถิ่น ด้วยการผสานการสนับสนุนสินทรัพย์ดิจิทัลเข้ากับวิธีการบริจาคแบบดั้งเดิมอย่างไร้รอยต่อ เรากำลังสร้างระบบนิเวศเงินทุนที่แข็งแกร่งซึ่งเปลี่ยนการบริจาคครั้งเดียวให้เป็นเครื่องยนต์สนับสนุนอย่างยั่งยืนสำหรับภารกิจที่สำคัญที่สุดของโลก",
    "home.comingSoon": "เร็วๆ นี้",
    "home.readDocs": "อ่านเอกสาร",
    "home.features.sectionTitle": "ประตูสู่การกุศลที่โปร่งใส",
    "home.features.sectionSubtitle":
      "โครงสร้างพื้นฐานหลายเชนสำหรับการบริจาคอย่างไร้รอยต่อ — คริปโตหรือเงินสด — ด้วยความโปร่งใสอย่างเต็มที่",
    "home.features.highEfficiency.title": "การให้ที่มีประสิทธิภาพสูง",
    "home.features.highEfficiency.description":
      "บริจาคโดยตรงให้กับองค์กรที่ผ่านการตรวจสอบอย่างชัดเจน ระบบบัญชีอัตโนมัติของเราให้การยืนยันแบบเรียลไทม์ เพื่อให้มั่นใจว่าการสนับสนุนของคุณถูกนำไปใช้ตรงจุดที่ต้องการมากที่สุด",
    "home.features.equityFunds.title": "กองทุนสมทบเพื่อการกุศล",
    "home.features.equityFunds.description":
      "ก้าวข้ามการบริจาคแบบครั้งเดียวด้วยการมีส่วนร่วมในกองทุนสมทบที่บริหารอย่างชาญฉลาด เราใช้กลยุทธ์ดิจิทัลที่ซับซ้อนและมีความเสี่ยงต่ำเพื่อเปลี่ยนเงินต้นของคุณให้เป็นกระแสเงินทุนอย่างยั่งยืน สนับสนุนภารกิจการกุศลต่อเนื่องข้ามรุ่น",
    "home.features.impactFunds.title": "กองทุนเพื่อผลกระทบ",
    "home.features.impactFunds.description":
      "รวมทรัพยากรเพื่อสาเหตุเฉพาะ สิ่งแวดล้อม การศึกษา การบรรเทาความยากจน — การบริจาคของคุณถูกขยายผลผ่านการร่วมมือกัน",
    "home.features.verifiedOrgs.title": "องค์กรที่ผ่านการตรวจสอบ",
    "home.features.verifiedOrgs.description":
      "เรียกดูองค์กรที่ลงทะเบียนหรือมองหาตราผ่านการตรวจสอบ องค์กรที่เข้าร่วมกระบวนการตรวจสอบของเราจะได้รับการรับรองบนบล็อกเชนที่ผู้บริจาคไว้วางใจได้",
    "home.features.blockchainVerified.title": "ยืนยันบนบล็อกเชน",
    "home.features.blockchainVerified.description":
      "โทเคนที่ผูกกับตัวตนใช้ยกย่องการมีส่วนร่วมของอาสาสมัคร ทักษะ ชั่วโมง และผลกระทบ — ทั้งหมดถูกบันทึกอย่างถาวรบนบล็อกเชน",
    "home.features.bridgingModes.title": "เชื่อมต่อทุกรูปแบบการให้",
    "home.features.bridgingModes.description":
      "ไม่ว่าคุณจะบริจาคเป็น USD หรือสินทรัพย์ดิจิทัล สถาปัตยกรรมหลายเครือข่ายของเราทำให้การบริจาคของคุณดำเนินไปอย่างรวดเร็วทันยุคสมัย",
    "home.roles.title": "สร้างขึ้นสำหรับทุกคนที่กำลังเปลี่ยนแปลงโลก",
    "home.roles.donors.title": "สำหรับผู้บริจาค",
    "home.roles.donors.item1": "บริจาคด้วยคริปโตหรือเงินสด — ตามที่คุณเลือก",
    "home.roles.donors.item2": "มีส่วนร่วมในการกำกับดูแล",
    "home.roles.donors.item3": "สร้างชื่อเสียงบนบล็อกเชน",
    "home.roles.nonprofits.title": "สำหรับองค์กรไม่แสวงหากำไร",
    "home.roles.nonprofits.item1": "เข้าถึงกลุ่มผู้บริจาคใหม่",
    "home.roles.nonprofits.item2": "เงินทุนที่ยั่งยืนผ่าน CEF",
    "home.roles.nonprofits.item3": "รายงานความโปร่งใสที่ดียิ่งขึ้น",
    "home.roles.volunteers.title": "สำหรับอาสาสมัคร",
    "home.roles.volunteers.item1": "บันทึกการมีส่วนร่วมที่ตรวจสอบได้",
    "home.roles.volunteers.item2": "ข้อมูลรับรองทักษะแบบพกพา (SBT)",
    "home.roles.volunteers.item3": "เหรียญรางวัลและการยกย่อง",
    "home.impact.title": "กองทุนเพื่อผลกระทบที่วางแผนไว้",
    "home.impact.environmental.title": "กองทุนผลกระทบด้านสิ่งแวดล้อม",
    "home.impact.environmental.description":
      "สนับสนุนการปลูกป่า การทำความสะอาดมหาสมุทร และโครงการพลังงานหมุนเวียน การบริจาคร่วมกันถูกส่งต่อไปยังองค์กรด้านสิ่งแวดล้อมที่ผ่านการตรวจสอบซึ่งสร้างผลกระทบที่วัดผลได้",
    "home.impact.education.title": "กองทุนโอกาสทางการศึกษา",
    "home.impact.education.description":
      "มอบทุนการศึกษา เครื่องมือการเรียนรู้ดิจิทัล และการฝึกอบรมครู เงินทุนร่วมถูกขยายผลเพื่อสนับสนุนโครงการการศึกษาในชุมชนที่ขาดแคลน",
    "home.cta.title": "พร้อมที่จะเปลี่ยนแปลงการให้หรือยัง?",
    "home.cta.subtitle":
      "เป็นกลุ่มแรกที่ได้สัมผัสการกุศลที่โปร่งใสและขับเคลื่อนด้วยบล็อกเชน เข้าร่วมชุมชนของเราในการสร้างอนาคตที่ดีกว่าสำหรับการให้เพื่อการกุศล",
    "home.cta.explore": "สำรวจสาเหตุ",
    "home.nav.features": "คุณสมบัติ",
    "home.nav.impact": "ผลกระทบ",
    "home.nav.charities": "องค์กรการกุศล",
    "home.nav.volunteer": "อาสาสมัคร",
    "home.footer.brand.tagline":
      "เปลี่ยนแปลงการกุศลด้วยความโปร่งใสของบล็อกเชนและเงินทุนที่ยั่งยืน",
    "home.footer.product.title": "ผลิตภัณฑ์",
    "home.footer.product.impactFunds": "กองทุนเพื่อผลกระทบ",
    "home.footer.product.charities": "สำหรับองค์กรการกุศล",
    "home.footer.product.volunteers": "สำหรับอาสาสมัคร",
    "home.footer.resources.title": "แหล่งข้อมูล",
    "home.footer.resources.whitepaper": "เอกสารสรุป (เร็วๆ นี้)",
    "home.footer.resources.blog": "บล็อก (เร็วๆ นี้)",
    "home.footer.resources.community": "ชุมชน (เร็วๆ นี้)",
    "home.footer.connect.title": "เชื่อมต่อ",
    "home.footer.connect.contact": "ติดต่อ (เร็วๆ นี้)",
    "home.footer.copyright":
      "Give Protocol หลายเชนโดยการออกแบบ ขับเคลื่อนโดยอาสาสมัคร Give Protocol",
    "auth.signin.welcomeBack": "ยินดีต้อนรับกลับ",
    "auth.signin.subtitle": "เข้าสู่ระบบบัญชี Give Protocol ของคุณ",
    "auth.signin.emailPlaceholder": "อีเมล",
    "auth.signin.passwordPlaceholder": "รหัสผ่าน",
    "auth.signin.submitting": "กำลังเข้าสู่ระบบ…",
    "auth.signin.withPasskey": "เข้าสู่ระบบด้วย Passkey",
    "auth.signin.withGoogle": "ดำเนินการต่อด้วย Google",
    "auth.signin.or": "หรือ",
    "auth.signin.newToProtocol": "ใหม่กับ Give Protocol?",
    "auth.signin.createAccount": "สร้างบัญชี →",
    "auth.signin.forgotPasswordLink": "ลืมรหัสผ่าน? →",
    "auth.signin.sslEncrypted": "เข้ารหัส TLS",
    "auth.signin.modeToggleLabel": "วิธีเข้าสู่ระบบ",
    "auth.signin.terms": "ข้อกำหนด",
    "auth.signin.privacy": "ความเป็นส่วนตัว",
    "auth.panel.headline": "การให้อย่างชาญฉลาด ผลกระทบที่โปร่งใส",
    "auth.panel.subheadline":
      "บัญชีเดียว บริจาคด้วยบัตรหรือคริปโต ติดตามทุกบาทบนบล็อกเชน",
    "auth.panel.statusLabel": "สถานะโปรโตคอล · ระยะเริ่มต้น",
    "auth.panel.statusDesc": "กำลังสร้างรากฐานของการให้ที่โปร่งใส",
    "auth.panel.runsOn": "ทำงานบน",
    "auth.wallet.connect": "เชื่อมต่อกระเป๋าเงิน",
    "auth.wallet.connecting": "กำลังเชื่อมต่อกระเป๋าเงิน…",
    "auth.wallet.signing": "กำลังลงนามข้อความ…",
    "auth.wallet.verifying": "กำลังตรวจสอบ…",
    "auth.wallet.openingSession": "กำลังเปิดเซสชัน…",
    "auth.validation.emailRequired": "กรุณากรอกที่อยู่อีเมลของคุณก่อน",
    "auth.validation.invalidEmail": "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
    "auth.validation.passwordTooShort":
      "รหัสผ่านต้องมีความยาวอย่างน้อย 8 ตัวอักษร",
    "auth.validation.passwordMismatch": "รหัสผ่านไม่ตรงกัน",
    "auth.login.welcomeHeading": "ยินดีต้อนรับสู่ Give Protocol",
    "auth.login.signInOrConnect": "เข้าสู่ระบบหรือเชื่อมต่อ",
    "auth.login.skipToContent": "ข้ามไปยังเนื้อหาการเข้าสู่ระบบ",
    "auth.login.donorTitle": "เข้าสู่ระบบผู้บริจาค",
    "auth.login.donorSubtitle":
      "เข้าสู่ระบบเพื่อเข้าถึงแดชบอร์ดการบริจาคของคุณ",
    "auth.login.charityTitle": "พอร์ทัลองค์กรไม่แสวงหากำไร",
    "auth.login.charitySubtitle": "จัดการโปรไฟล์องค์กรและการบริจาค",
    "auth.login.back": "← กลับ",
    "auth.login.continueDonor": "ดำเนินการต่อเป็นผู้บริจาค",
    "auth.login.connecting": "กำลังเชื่อมต่อ…",
    "auth.login.connectWalletSignIn": "เชื่อมต่อกระเป๋าเงินและเข้าสู่ระบบ",
    "auth.login.newToPlatform": "ใหม่กับ Give Protocol?",
    "auth.login.newDonorSignUp": "ลงทะเบียนผู้บริจาคใหม่",
    "auth.login.manageNonprofit": "ฉันจัดการโปรไฟล์องค์กรไม่แสวงหากำไร",
    "auth.login.nonprofitTrayTitle": "ใหม่กับ Give Protocol?",
    "auth.login.createNonprofitAccount": "สร้างบัญชีองค์กรไม่แสวงหากำไร",
    "auth.login.registerOrg": "ลงทะเบียนองค์กรของคุณบน Give Protocol",
    "auth.login.needHelp": "ต้องการความช่วยเหลือ?",
    "auth.login.forgotUsernameBtn": "ลืมชื่อผู้ใช้?",
    "auth.login.forgotPasswordBtn": "ลืมรหัสผ่าน?",
    "auth.donorLogin.mismatch":
      "ไม่พบบัญชีผู้บริจาค อีเมลนี้ลงทะเบียนเป็นบัญชีองค์กรการกุศล กรุณาใช้การเข้าสู่ระบบสำหรับองค์กรการกุศล",
    "auth.donorLogin.signingIn": "กำลังเข้าสู่ระบบ…",
    "auth.donorLogin.redirecting": "กำลังเปลี่ยนเส้นทางใน {{count}}...",
    "auth.donorReg.pleaseWait": "กรุณารอสักครู่…",
    "auth.donorReg.signUpPasskey": "สมัครด้วย Passkey",
    "auth.donorReg.withGoogle": "ดำเนินการต่อด้วย Google",
    "auth.donorReg.connectWallet": "เชื่อมต่อกระเป๋าเงิน",
    "auth.donorReg.orSetPassword": "หรือตั้งรหัสผ่าน",
    "auth.donorReg.creating": "กำลังสร้างบัญชี...",
    "auth.donorReg.createAccount": "สร้างบัญชีผู้บริจาค",
    "auth.donorReg.privacyNotice": "การสร้างบัญชีแสดงว่าคุณยอมรับ",
    "auth.donorReg.termsLink": "ข้อกำหนดการใช้บริการ",
    "auth.donorReg.privacyAnd": "และรับทราบ",
    "auth.donorReg.privacyLink": "นโยบายความเป็นส่วนตัว",
    "auth.charityLogin.mismatch":
      "อีเมลนี้ลงทะเบียนเป็นบัญชีผู้บริจาค กรุณาเข้าสู่ระบบที่พอร์ทัลผู้บริจาค",
    "auth.charityLogin.signingIn": "กำลังเข้าสู่ระบบ...",
    "auth.charityLogin.or": "หรือ",
    "auth.charityLogin.connecting": "กำลังเชื่อมต่อ...",
    "auth.charityLogin.connectWallet": "เชื่อมต่อกระเป๋าเงิน",
    "auth.forgot.resetPassword": "รีเซ็ตรหัสผ่าน",
    "auth.forgot.forgotUsername": "ลืมชื่อผู้ใช้",
    "auth.forgot.passwordDesc":
      "กรอกที่อยู่อีเมลของคุณ แล้วเราจะส่งลิงก์สำหรับรีเซ็ตรหัสผ่านให้คุณ",
    "auth.forgot.usernameDesc":
      "กรอกที่อยู่อีเมลของคุณ แล้วเราจะส่งชื่อผู้ใช้ให้คุณ",
    "auth.forgot.passwordSuccess":
      "คำแนะนำในการรีเซ็ตรหัสผ่านถูกส่งไปยังอีเมลของคุณแล้ว",
    "auth.forgot.usernameSuccess":
      "การแจ้งเตือนชื่อผู้ใช้ถูกส่งไปยังอีเมลของคุณแล้ว",
    "auth.forgot.checkEmail": "ตรวจสอบอีเมลของคุณ",
    "auth.forgot.backToSignIn": "กลับไปยังการเข้าสู่ระบบ",
    "auth.forgot.emailPlaceholder": "กรอกที่อยู่อีเมลของคุณ",
    "auth.forgot.genericError": "เกิดข้อผิดพลาด กรุณาลองอีกครั้ง",
    "auth.forgot.sending": "กำลังส่ง...",
    "auth.forgot.sendResetLink": "ส่งลิงก์รีเซ็ต",
    "auth.forgot.sendUsername": "ส่งชื่อผู้ใช้",

    // Reset password (set new password page) — pending translation (GIV-367)
    "auth.resetPassword.title": "Set New Password",
    "auth.resetPassword.subtitle": "Choose a strong password for your account.",
    "auth.resetPassword.newPassword": "New Password",
    "auth.resetPassword.confirmPassword": "Confirm New Password",
    "auth.resetPassword.submit": "Update Password",
    "auth.resetPassword.updating": "Updating\u2026",
    "auth.resetPassword.mismatch": "Passwords do not match.",
    "auth.resetPassword.success": "Password updated successfully!",
    "auth.resetPassword.successSubtitle":
      "You can now sign in with your new password.",
    "auth.resetPassword.backToSignIn": "Back to Sign In",
    "auth.resetPassword.invalidLink":
      "This password reset link is invalid or has expired.",
    "auth.resetPassword.requestNew": "Request a new reset link",
    "auth.resetPassword.validating": "Validating reset link\u2026",
    "auth.orgSearch.orgNameLabel": "ชื่อองค์กร",
    "auth.orgSearch.searchPlaceholder": "ค้นหาตามชื่อองค์กร...",
    "auth.orgSearch.countryLabel": "ประเทศ",
    "auth.orgSearch.allCountries": "ทุกประเทศ",
    "auth.orgSearch.searchPrompt":
      "ค้นหาในฐานข้อมูลของเราเพื่อค้นหาและอ้างสิทธิ์องค์กรของคุณ",
    "auth.orgSearch.noResults": "ไม่พบองค์กร",
    "auth.orgSearch.loadMore": "โหลดผลลัพธ์เพิ่มเติม",
    "auth.orgSearch.cantFind": "ไม่พบองค์กรของคุณ?",
    "auth.orgSearch.registerManually": "ลงทะเบียนด้วยตนเอง",
    "charity.claim.orgDetails": "รายละเอียดองค์กร (จากทะเบียน)",
    "charity.claim.orgNameLabel": "ชื่อ",
    "charity.claim.einLabel": "เลขประจำตัวผู้เสียภาษี",
    "charity.claim.locationLabel": "ที่ตั้ง",
    "charity.claim.contactInfo": "ข้อมูลติดต่อ",
    "charity.claim.contactName": "ชื่อผู้ติดต่อ",
    "charity.claim.contactEmail": "อีเมลผู้ติดต่อ",
    "charity.claim.accountSecurity": "ความปลอดภัยของบัญชี",
    "charity.claim.password": "รหัสผ่าน",
    "charity.claim.confirmPassword": "ยืนยันรหัสผ่าน",
    "charity.claim.backToSearch": "กลับไปค้นหา",
    "charity.claim.creating": "กำลังสร้างบัญชี...",
    "charity.claim.submit": "อ้างสิทธิ์องค์กร",
    "charity.claim.validation.name":
      "ชื่อต้องมีความยาวระหว่าง 2 ถึง 100 ตัวอักษร",
    "charity.claim.validation.email": "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
    "charity.claim.validation.password":
      "รหัสผ่านต้องมีความยาวอย่างน้อย 8 ตัวอักษร",
    "charity.claim.validation.confirmPassword": "รหัสผ่านไม่ตรงกัน",
    "charity.claim.validation.fix": "กรุณาแก้ไขข้อผิดพลาดในการตรวจสอบ",
    "charity.claim.useAsPublicEmail":
      "ใช้อีเมลของฉันเป็นอีเมลติดต่อสาธารณะขององค์กร",
    "charity.claim.publicContactEmail": "อีเมลติดต่อสาธารณะขององค์กร",
    "charity.claim.privacyNotice":
      "อีเมล/โทรศัพท์ส่วนตัวของผู้ลงนามใช้สำหรับการยืนยันตัวตนเท่านั้นและไม่แสดงให้ผู้ใช้แพลตฟอร์มอื่นเห็น อีเมลติดต่อสาธารณะจะแสดงในโปรไฟล์องค์กรของคุณ",
    "charity.claim.secondContactTitle": "ผู้ติดต่อสำรอง",
    "charity.claim.secondContactName": "ชื่อผู้ติดต่อสำรอง",
    "charity.claim.secondContactEmail": "อีเมลผู้ติดต่อสำรอง",
    "charity.claim.secondContactHint":
      "บุคคลอื่นที่จะได้รับการแจ้งเตือนเมื่อกระเป๋าเงินหรือรายละเอียดการจ่ายเงินขององค์กรการกุศลของคุณมีการเปลี่ยนแปลง",
    "charity.claim.validation.secondEmailDistinct":
      "อีเมลของผู้ติดต่อสำรองต้องแตกต่างจากอีเมลหลัก",
    "charity.claim.error.creation": "การสร้างบัญชีล้มเหลว",
    "charity.claim.error.generic": "ไม่สามารถสร้างบัญชีได้",
    "charity.vetting.orgDetails": "รายละเอียดองค์กร",
    "charity.vetting.orgName": "ชื่อองค์กร",
    "charity.vetting.description": "รายละเอียด",
    "charity.vetting.taxId": "เลขประจำตัวผู้เสียภาษีหรือเลขทะเบียน",
    "charity.vetting.countryLabel": "ประเทศ",
    "charity.vetting.selectCountry": "เลือกประเทศ",
    "charity.vetting.address": "ที่อยู่",
    "charity.vetting.streetAddress": "ที่อยู่ถนน",
    "charity.vetting.city": "เมือง",
    "charity.vetting.state": "รัฐ/จังหวัด",
    "charity.vetting.postalCode": "รหัสไปรษณีย์",
    "charity.vetting.contactInfo": "ข้อมูลติดต่อ",
    "charity.vetting.contactName": "ชื่อผู้ติดต่อ",
    "charity.vetting.contactEmail": "อีเมลผู้ติดต่อ",
    "charity.vetting.accountSecurity": "ความปลอดภัยของบัญชี",
    "charity.vetting.password": "รหัสผ่าน",
    "charity.vetting.confirmPassword": "ยืนยันรหัสผ่าน",
    "charity.vetting.submitting": "กำลังส่งใบสมัคร...",
    "charity.vetting.submit": "ส่งใบสมัครองค์กรการกุศล",
    "charity.vetting.validation.orgName":
      "ชื่อองค์กรต้องมีความยาวระหว่าง 2 ถึง 100 ตัวอักษร",
    "charity.vetting.validation.contactName":
      "ชื่อผู้ติดต่อต้องมีความยาวระหว่าง 2 ถึง 100 ตัวอักษร",
    "charity.vetting.validation.email": "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
    "charity.vetting.validation.password":
      "รหัสผ่านต้องมีความยาวอย่างน้อย 8 ตัวอักษร",
    "charity.vetting.validation.confirmPassword": "รหัสผ่านไม่ตรงกัน",
    "charity.vetting.validation.description": "จำเป็นต้องกรอกรายละเอียด",
    "charity.vetting.validation.category": "จำเป็นต้องเลือกหมวดหมู่",
    "charity.vetting.validation.taxId": "จำเป็นต้องกรอกเลขประจำตัวผู้เสียภาษี",
    "charity.vetting.validation.streetAddress": "จำเป็นต้องกรอกที่อยู่ถนน",
    "charity.vetting.validation.city": "จำเป็นต้องกรอกเมือง",
    "charity.vetting.validation.country": "จำเป็นต้องเลือกประเทศ",
    "charity.vetting.validation.fix": "กรุณาแก้ไขข้อผิดพลาดในการตรวจสอบ",
    "charity.vetting.error.generic": "ไม่สามารถส่งใบสมัครได้",
    "charity.vetting.privacyNotice": "การส่งใบสมัครนี้แสดงว่าคุณยอมรับ",
    "charity.vetting.termsLink": "ข้อกำหนดการใช้บริการ",
    "charity.vetting.privacyAnd": "และรับทราบ",
    "charity.vetting.privacyLink": "นโยบายความเป็นส่วนตัว",
    "common.email": "อีเมล",
    "common.password": "รหัสผ่าน",
    "common.confirmPassword": "ยืนยันรหัสผ่าน",
    "footer.brand.tagline": "ขจัดอุปสรรคสู่การบริจาคเพื่อการกุศลอย่างยั่งยืน",
    "footer.resources.title": "แหล่งข้อมูล",
    "footer.resources.faq": "คำถามที่พบบ่อย",
    "footer.resources.about": "เกี่ยวกับเรา",
    "footer.legal.title": "กฎหมาย",
    "footer.legal.terms": "ข้อกำหนดการใช้บริการ",
    "footer.legal.privacy": "นโยบายความเป็นส่วนตัว",
    "footer.legal.cookiePreferences": "การตั้งค่าคุกกี้",
    "consent.banner.ariaLabel": "ความยินยอมเกี่ยวกับคุกกี้",
    "consent.banner.body":
      "เราใช้ Google Analytics 4 (Google LLC สหรัฐอเมริกา) และ Sentry (Functional Software สหรัฐอเมริกา/สหภาพยุโรป) เพื่อทำความเข้าใจการใช้งานแอปและตรวจจับข้อผิดพลาด ไม่มีการแชร์อีเมล ที่อยู่กระเป๋าเงิน หรือชื่อผู้บริจาค คุณสามารถถอนความยินยอมได้ทุกเมื่อ",
    "consent.banner.privacyLink": "นโยบายความเป็นส่วนตัว",
    "consent.banner.acceptAll": "ยอมรับทั้งหมด",
    "consent.banner.decline": "ปฏิเสธที่ไม่จำเป็น",
    "consent.banner.customize": "ปรับแต่ง",
    "consent.modal.title": "การตั้งค่าคุกกี้",
    "consent.modal.essentialTitle": "จำเป็น",
    "consent.modal.essentialDesc":
      "จำเป็นสำหรับฟีเจอร์หลักของเว็บไซต์ เช่น การนำทางและการยืนยันตัวตน ไม่สามารถปิดใช้งานได้",
    "consent.modal.essentialAlwaysOn": "คุกกี้ที่จำเป็น — เปิดใช้งานเสมอ",
    "consent.modal.analyticsTitle":
      "การวิเคราะห์ (Google Analytics 4 · สหรัฐอเมริกา, Sentry · สหรัฐอเมริกา/สหภาพยุโรป)",
    "consent.modal.analyticsDesc":
      "คุกกี้การวิเคราะห์ช่วยให้เราเข้าใจว่าหน้าไหนถูกเข้าชมและผู้ใช้นำทางในแอปอย่างไร เราใช้ Google Analytics 4 \u2014 ตัวระบุเซสชัน, URL ของหน้า, ข้อมูลเมตาของอุปกรณ์/เบราว์เซอร์, ตำแหน่งโดยประมาณจาก IP ที่ไม่ระบุตัวตน (Google LLC สหรัฐอเมริกา; SCCs + EU\u2013US Data Privacy Framework) Sentry \u2014 การติดตามข้อผิดพลาดที่ไม่ระบุตัวตนและข้อมูลเมตาของเบราว์เซอร์เพื่อการเฝ้าระวังความเสถียร (Functional Software สหภาพยุโรป/สหรัฐอเมริกา; กลไกการถ่ายโอนอยู่ระหว่างดำเนินการ) ไม่มีการแชร์อีเมล ที่อยู่กระเป๋าเงิน หรือชื่อผู้บริจาคกับผู้ประมวลผลข้อมูลใดๆ",
    "consent.modal.analyticsOn": "การวิเคราะห์และบันทึกข้อผิดพลาด — เปิด",
    "consent.modal.analyticsOff": "การวิเคราะห์และบันทึกข้อผิดพลาด — ปิด",
    "consent.modal.cancel": "ยกเลิก",
    "consent.modal.save": "บันทึกการตั้งค่า",
    "footer.connect.title": "เชื่อมต่อ",
    "footer.copyright": "Give Protocol สงวนลิขสิทธิ์",
    "nav.signIn": "เข้าสู่ระบบ",
    "nav.signOut": "ออกจากระบบ",
    "nav.privacy": "ความเป็นส่วนตัว",
    "auth.signup.heading": "สร้างบัญชีของคุณ",
    "auth.signup.subtitle": "เข้าร่วมขบวนการให้ที่โปร่งใส",
    "auth.signup.displayName": "ชื่อที่แสดง",
    "auth.signup.emailPlaceholder": "อีเมล",
    "auth.signup.passwordPlaceholder": "รหัสผ่าน",
    "auth.signup.confirmPasswordPlaceholder": "ยืนยันรหัสผ่าน",
    "auth.signup.submit": "สร้างบัญชี",
    "auth.signup.submitting": "กำลังสร้างบัญชี…",
    "auth.signup.withPasskey": "สมัครด้วย Passkey",
    "auth.signup.withGoogle": "ดำเนินการต่อด้วย Google",
    "auth.signup.connectWallet": "เชื่อมต่อกระเป๋าเงิน",
    "auth.signup.orSetPassword": "หรือตั้งรหัสผ่าน",
    "auth.signup.alreadyHaveAccount": "มีบัญชีอยู่แล้ว?",
    "auth.signup.signInLink": "เข้าสู่ระบบ",
    "auth.signup.manageNonprofit": "จัดการองค์กรไม่แสวงหากำไร?",
    "auth.signup.trustText": "ข้อมูลของคุณได้รับการปกป้องโดย",
    "auth.signup.and": "และ",
    "auth.signup.privacyPolicy": "นโยบายความเป็นส่วนตัว",
    "auth.signup.panel.headline": "การให้ที่คุณตรวจสอบได้",
    "browse.hero.title": "การให้ ยืนยันบนบล็อกเชน",
    "browse.hero.subtitle":
      "ค้นพบสาเหตุที่ผ่านการคัดเลือก บริจาคด้วยบัตรหรือสินทรัพย์ดิจิทัล และเห็นผลกระทบที่จับต้องได้จากเวลาและทรัพยากรของคุณ",
    "browse.stats.networks": "เครือข่ายที่รองรับ",
    "browse.stats.sectors": "ภาคการกุศล",
    "browse.stats.verifiedOrgs": "องค์กรที่ผ่านการตรวจสอบ",
    "browse.stats.volunteerHours": "ชั่วโมงอาสาสมัคร",
    "browse.verified": "ผ่านการตรวจสอบ",
    "browse.donate": "บริจาค",
    "browse.viewProfile": "ดูโปรไฟล์",
    "browse.filter.ariaLabel": "กรององค์กรการกุศล",
    "browse.filter.searchAria": "ค้นหาองค์กรการกุศล",
    "browse.filter.locationAria": "ค้นหาสถานที่",
    "browse.results.ariaLabel": "ผลลัพธ์องค์กรการกุศล",
    "browse.tabs.charities": "องค์กรการกุศล",
    "browse.tabs.causes": "สาเหตุ",
    "browse.tabs.funds": "กองทุนพอร์ตโฟลิโอ",
    "browse.tabs.ariaLabel": "เรียกดูหมวดหมู่",
    "browse.featured.heading": "องค์กรแนะนำ",
    "browse.featured.ariaLabel": "องค์กรแนะนำ",
    "browse.featured.nextAria": "องค์กรแนะนำถัดไป",
    "browse.causes.heading": "สาเหตุแนะนำ",
    "browse.causes.ariaLabel": "สาเหตุแนะนำ",
    "browse.causes.badge": "สาเหตุ",
    "browse.causes.raised": "ระดมได้",
    "browse.causes.percentOf": "% ของ",
    "browse.causes.by": "โดย",
    "browse.causes.supportCta": "สนับสนุนสาเหตุนี้",
    "browse.causes.giveCta": "บริจาค",
    "browse.causes.nextAria": "สาเหตุแนะนำถัดไป",
    "browse.funds.heading": "กองทุนพอร์ตโฟลิโอ",
    "browse.funds.ariaLabel": "กองทุนพอร์ตโฟลิโอ",
    "browse.funds.badge": "กองทุนพอร์ตโฟลิโอ",
    "browse.funds.charity": "องค์กร",
    "browse.funds.charities": "องค์กร",
    "browse.funds.donateCta": "บริจาคให้กองทุน",
    "browse.funds.nextAria": "กองทุนพอร์ตโฟลิโอถัดไป",
    "portfolio.notFound.title": "ไม่พบกองทุนพอร์ตโฟลิโอ",
    "portfolio.notFound.body":
      "กองทุนพอร์ตโฟลิโอที่คุณกำลังค้นหาไม่มีอยู่หรือไม่ได้ใช้งานแล้ว",
    "portfolio.supportedOrgs": "องค์กรที่ได้รับการสนับสนุน",
    "browse.charity.einLabel": "เลขประจำตัวผู้เสียภาษี",
    "browse.charity.einDisplay": "เลขประจำตัวผู้เสียภาษี: {{value}}",
    "browse.charity.nteeLabel": "รหัสภาคส่วน",
    "browse.charity.deductibilityLabel": "การลดหย่อนภาษี",
    "browse.charity.onPlatform": "บนแพลตฟอร์ม",
    "browse.charity.loading": "กำลังโหลด…",
    "browse.charity.loadMore": "โหลดเพิ่มเติม",
    "browse.filter.searchPlaceholder": "ค้นหาองค์กรการกุศล...",
    "browse.filter.locationPlaceholder": "เมือง รัฐ หรือประเทศ...",
    "browse.whyGiveProtocol.heading": "ทำไมต้อง Give Protocol?",
    "browse.whyGiveProtocol.verified.title":
      "องค์กรไม่แสวงหาผลกำไรที่ผ่านการตรวจสอบ",
    "browse.whyGiveProtocol.verified.description":
      "ทุกองค์กรจะถูกตรวจสอบกับทะเบียนสาธารณะก่อนที่จะปรากฏบนแพลตฟอร์ม",
    "browse.whyGiveProtocol.onchain.title": "ความโปร่งใสบนบล็อกเชน",
    "browse.whyGiveProtocol.onchain.description":
      "การบริจาคถูกบันทึกบนบล็อกเชนเพื่อให้คุณสามารถติดตามผลกระทบจากกระเป๋าเงินไปจนถึงเป้าหมาย",
    "browse.whyGiveProtocol.volunteer.title": "ให้เวลา ไม่ใช่แค่เงิน",
    "browse.whyGiveProtocol.volunteer.description":
      "ชั่วโมงอาสาสมัครจะได้รับการยืนยันจากองค์กรการกุศลและนับเข้าสู่ชื่อเสียงของคุณในโปรโตคอล",
    "browse.news.heading": "ข่าวสารแพลตฟอร์ม",
    "admin.news.deleteConfirmBody": "“{{title}}” จะถูกลบอย่างถาวร และไม่สามารถย้อนกลับได้",
    "admin.news.deleteConfirmTitle": "ลบข่าวนี้หรือไม่?",
    "admin.news.saveFailed": "ไม่สามารถบันทึกการเปลี่ยนแปลงได้ โปรดลองอีกครั้ง",
    "admin.news.urlHelp": "ไม่บังคับ เว้นว่างไว้เพื่อแสดงข่าวโดยไม่มีลิงก์",
    "admin.news.urlInvalid": "ป้อนที่อยู่ https:// แบบเต็ม หรือพาธที่ขึ้นต้นด้วย /",
    "browse.carousel.error": "ไม่สามารถโหลดส่วนนี้ได้ โปรดรีเฟรชหน้าแล้วลองอีกครั้ง",
    "browse.carousel.goToPage": "ไปที่หน้า {{page}}",
    "browse.carousel.pageLabel": "หน้า {{current}} จาก {{total}}",
    "browse.carousel.pause": "หยุดการสลับอัตโนมัติชั่วคราว",
    "browse.carousel.play": "เล่นการสลับอัตโนมัติต่อ",
    "browse.causes.empty": "ยังไม่มีสาเหตุให้แสดง โปรดกลับมาตรวจสอบใหม่เร็วๆ นี้!",
    "browse.causes.prevAria": "สาเหตุเด่นก่อนหน้า",
    "browse.causes.searchPlaceholder": "ค้นหาสาเหตุ...",
    "browse.causes.subheading": "สนับสนุนโครงการที่สร้างผลกระทบที่แท้จริง",
    "browse.charity.registryIdDisplay": "รหัสทะเบียน: {{value}}",
    "browse.featured.empty": "ยังไม่มีองค์กรเด่น ใช้การค้นหาด้านบนเพื่อค้นหาองค์กรการกุศล",
    "browse.featured.prevAria": "องค์กรเด่นก่อนหน้า",
    "browse.featured.subheading": "ภาพรวมแบบหมุนเวียนขององค์กรการกุศลที่ผ่านการตรวจสอบบน Give Protocol",
    "browse.filter.addLocation": "เพิ่มสถานที่",
    "browse.filter.impactNotice": "ตัวกรองตามสถานที่ที่ได้รับผลกระทบยังไม่พร้อมใช้งาน ผลลัพธ์จึงไม่ถูกจำกัดตามสถานที่ดังกล่าว",
    "browse.filter.locationHint": "กด Enter หรือเลือก เพิ่ม เพื่อใช้สถานที่",
    "browse.filter.minChars": "พิมพ์อย่างน้อย 2 ตัวอักษรเพื่อค้นหา",
    "browse.funds.empty": "ยังไม่มีกองทุนพอร์ตโฟลิโอ โปรดกลับมาตรวจสอบใหม่เร็วๆ นี้!",
    "browse.funds.prevAria": "กองทุนพอร์ตโฟลิโอก่อนหน้า",
    "browse.funds.searchPlaceholder": "ค้นหากองทุนพอร์ตโฟลิโอ...",
    "browse.funds.subheading": "พอร์ตโฟลิโอการบริจาคที่คัดสรรมา กระจายเงินบริจาคไปยังองค์กรการกุศลที่ผ่านการตรวจสอบ",
    "browse.registry.badge": "ลงทะเบียนกับ {{registry}}",
    "browse.results.empty": "ไม่มีองค์กรที่ตรงกับการค้นหานี้ ลองใช้คำอื่นหรือเพิ่มตัวกรองสถานที่",
    "browse.results.error": "ไม่สามารถค้นหาได้ โปรดลองอีกครั้ง",
    "browse.search.noMatches": "ไม่พบรายการที่ตรงกับ “{{query}}”",
    "browse.category.A": "ศิลปะและวัฒนธรรม",
    "browse.category.B": "การศึกษา",
    "browse.category.C": "สิ่งแวดล้อม",
    "browse.category.D": "สวัสดิภาพสัตว์",
    "browse.category.E": "สุขภาพ",
    "browse.category.F": "สุขภาพจิต",
    "browse.category.G": "วิจัยทางการแพทย์",
    "browse.category.H": "วิจัยชีวการแพทย์",
    "browse.category.I": "อาชญากรรมและกฎหมาย",
    "browse.category.J": "การจ้างงาน",
    "browse.category.K": "อาหารและโภชนาการ",
    "browse.category.L": "ที่อยู่อาศัย",
    "browse.category.M": "ความปลอดภัยสาธารณะ",
    "browse.category.N": "นันทนาการ",
    "browse.category.O": "การพัฒนาเยาวชน",
    "browse.category.P": "บริการด้านมนุษยชน",
    "browse.category.Q": "ระหว่างประเทศ",
    "browse.category.R": "สิทธิพลเมือง",
    "browse.category.S": "การพัฒนาชุมชน",
    "browse.category.T": "การกุศลเพื่อสังคม",
    "browse.category.U": "วิทยาศาสตร์และเทคโนโลยี",
    "browse.category.V": "สังคมศาสตร์",
    "browse.category.W": "นโยบายสาธารณะ",
    "browse.category.X": "ศาสนา",
    "browse.category.Y": "ผลประโยชน์ร่วมกัน",
    "browse.category.default": "องค์กรไม่แสวงหากำไร",
    "cause.causes": "สาเหตุ",
    "cause.createNew": "สร้างใหม่",
    "cause.noCausesTitle": "ยังไม่มีสาเหตุ",
    "cause.name": "ชื่อ",
    "cause.description": "รายละเอียด",
    "cause.category": "หมวดหมู่",
    "cause.targetAmount": "จำนวนเป้าหมาย",
    "cause.headerImage": "ภาพส่วนหัว",
    "cause.impact": "ผลกระทบ",
    "cause.impactHelp": "อธิบายผลกระทบที่คาดหวังของสาเหตุนี้",
    "cause.location": "สถานที่",
    "cause.timeline": "ระยะเวลา",
    "cause.partners": "พันธมิตร",
    "cause.limitReached": "ถึงขีดจำกัดสาเหตุแล้ว",
    "impact.statistics": "สถิติผลกระทบ",
    "impact.statLabel": "ป้ายกำกับ",
    "impact.statValue": "ค่า",
    "impact.missionStatement": "พันธกิจ",
    "impact.missionPlaceholder": "พันธกิจของเราคือ...",
    "impact.highlights": "จุดเด่นของผลกระทบ",
    "impact.highlight": "จุดเด่นผลกระทบ",
    "impact.addHighlight": "เพิ่มจุดเด่น",
    "impact.profile": "โปรไฟล์ผลกระทบ",
    "impact.loadError": "ไม่สามารถโหลดโปรไฟล์ผลกระทบได้",
    "impact.saveError": "ไม่สามารถบันทึกโปรไฟล์ผลกระทบได้",
    "impact.saveSuccess": "บันทึกโปรไฟล์ผลกระทบสำเร็จ",
    "organization.yearFounded": "ปีที่ก่อตั้ง",
    "organization.address": "ที่อยู่",
    "organization.street": "ที่อยู่ถนน",
    "organization.city": "เมือง",
    "organization.stateProvince": "รัฐ/จังหวัด",
    "organization.postalCode": "รหัสไปรษณีย์",
    "organization.country": "ประเทศ",
    "organization.contactInfo": "ข้อมูลติดต่อ",
    "organization.phone": "โทรศัพท์",
    "organization.email": "อีเมล",
    "organization.website": "เว็บไซต์",
    "organization.socialMedia": "สื่อสังคมออนไลน์",
    "organization.publicFeed": "ฟีดสาธารณะ",
    "organization.communityMedia": "ชุมชนและสื่อ",
    "organization.profile": "โปรไฟล์องค์กร",
    "organization.loadError": "ไม่สามารถโหลดโปรไฟล์องค์กรได้",
    "organization.saveError": "ไม่สามารถบันทึกโปรไฟล์องค์กรได้",
    "common.remove": "ลบ",
    "common.saveChanges": "บันทึกการเปลี่ยนแปลง",
    "dashboard.thisMonth": "เดือนนี้",
    "dashboard.verified": "อาสาสมัครที่ผ่านการตรวจสอบ",
    "dashboard.hoursLogged": "ชั่วโมงที่บันทึก",
    "dashboard.endorsements": "การรับรอง",
    "dashboard.organizationsHelped": "องค์กรที่ช่วยเหลือ",
    "dashboard.yourOrganizationsHelped": "องค์กรที่คุณช่วยเหลือ",
    "transactions.createCampaign": "สร้างแคมเปญแรกของคุณ",
    "contributions.emptyTitle": "การเดินทางแห่งการให้ของคุณเริ่มต้นที่นี่",
    "contributions.browseCharities": "เรียกดูองค์กรการกุศล",
    "charity.profile.verified501c3": "องค์กรไม่แสวงหาผลกำไรที่ผ่านการตรวจสอบ",
    "charity.profile.verified501c3Tooltip":
      "องค์กร 501(c)(3) ที่จดทะเบียน — การบริจาคอาจหักลดหย่อนภาษีได้ในสหรัฐอเมริกา",
    "charity.profile.statusClaimed": "อ้างสิทธิ์แล้ว",
    "charity.profile.statusUnclaimed":
      "ยังไม่อ้างสิทธิ์ — ข้อมูลจากทะเบียนสาธารณะเท่านั้น",
    "charity.profile.statusIrsVerified":
      "องค์กรไม่แสวงหาผลกำไรที่ผ่านการตรวจสอบโดย IRS",
    "charity.profile.requestWidget.unclaimedBody":
      "องค์กรนี้ยังไม่ได้อ้างสิทธิ์โปรไฟล์บน Give Protocol การบริจาคจะพร้อมใช้งานเมื่อองค์กรอ้างสิทธิ์โปรไฟล์และตั้งค่ากระเป๋าเงินเรียบร้อยแล้ว",
    "charity.profile.rowEin": "เลขประจำตัวผู้เสียภาษี",
    "charity.profile.rowName": "ชื่อ",
    "charity.profile.rowLocation": "ที่ตั้ง",
    "charity.profile.rowRulingYear": "ปีที่จดทะเบียน",
    "charity.profile.rowNteeCode": "รหัสภาคส่วน",
    "charity.profile.rowDeductibility": "การลดหย่อนภาษี",
    "charity.profile.rowAffiliation": "สังกัด",
    "charity.profile.rowClassification": "การจัดประเภท",
    "charity.profile.rowFoundation": "ประเภทมูลนิธิ",
    "charity.profile.rowActivityCodes": "รหัสกิจกรรม",
    "charity.profile.rowOrgType": "ประเภทองค์กร",
    "charity.profile.rowSubsection": "มาตราย่อย",
    "charity.profile.rowStatus": "สถานะ",
    "charity.profile.registryRecord": "บันทึกสาธารณะจากทะเบียน",
    "charity.profile.einDisplay": "เลขประจำตัวผู้เสียภาษี",
    "charity.profile.charityNotFoundByTaxId":
      "ไม่พบองค์กรการกุศลที่มีเลขประจำตัวผู้เสียภาษีนี้",
    "charity.profile.registeredNonprofit": "องค์กรไม่แสวงหาผลกำไรที่จดทะเบียน",
    "charity.profile.registeredYear": "จดทะเบียน {{year}}",
    "charity.profile.shareAria": "แชร์",
    "charity.profile.copied": "คัดลอกแล้ว!",
    "charity.profile.about": "เกี่ยวกับ",
    "charity.profile.claimProfile": "อ้างสิทธิ์โปรไฟล์นี้",
    "charity.profile.noDescription": "ไม่มีรายละเอียด",
    "charity.profile.toAddOne": "เพื่อเพิ่มรายละเอียด",
    "charity.profile.contact": "ติดต่อ",
    "charity.profile.donate.support": "สนับสนุน",
    "charity.profile.donate.walletUnset":
      "องค์กรนี้ยังไม่ได้ตั้งค่ากระเป๋าเงินรับอย่างเป็นทางการ",
    "charity.profile.donate.walletPending":
      "องค์กรนี้กำลังตั้งค่ากระเป๋าเงิน — การบริจาคไม่สามารถใช้ได้ชั่วคราว",
    "charity.profile.donate.walletLegacy":
      "องค์กรนี้ใช้ที่อยู่กระเป๋าเงินรุ่นเก่า",
    "charity.profile.donate.feeNote":
      "ค่าธรรมเนียมแพลตฟอร์ม 0% สำหรับการบริจาคโดยตรง มีค่าธรรมเนียมเครือข่าย",
    "charity.profile.donate.jurisdictionUnavailable":
      "การบริจาคให้กับองค์กรการกุศลนอกสหรัฐอเมริกายังไม่พร้อมให้บริการบน Give Protocol",
    "portfolio.title": "กองทุนพอร์ตโฟลิโอ",
    "settings.displayPreferences": "การตั้งค่าการแสดงผล",
    "settings.theme": "ธีม",
    "settings.light": "สว่าง",
    "settings.dark": "มืด",
    "auth.toast.welcomeBack": "Welcome back, {{firstName}}",
    "auth.toast.youreSignedIn": "You're signed in.",
    "auth.toast.walletConnected": "Wallet connected",
    "auth.toast.signedInWith": "Signed in with {{address}}.",
    "auth.toast.signedOut": "Signed out",
    "auth.toast.signInFailed": "Sign-in failed",
    "auth.toast.signOutFailed": "Sign-out failed",
    "donation.toast.received": "Donation received",
    "donation.toast.receivedMessage":
      "Thank you — your tax receipt is on the way.",
    "donation.toast.submitted": "Transaction submitted",
    "donation.toast.submittedMessage": "Waiting for on-chain confirmation…",
    "donation.toast.confirmed": "Donation confirmed",
    "donation.toast.confirmedMessage":
      "Your contribution is recorded on-chain.",
    "donation.toast.failed": "Donation failed",

    // Art. 9(2)(a) donation consent (GIV-655)
    "donation.art9Consent.statement":
      "ข้าพเจ้าเข้าใจว่าบันทึกการบริจาคของข้าพเจ้าเชื่อมโยงข้าพเจ้ากับ {{charity}} ในกรณีที่สิ่งนี้อาจบ่งชี้ถึงความเกี่ยวข้องทางศาสนา การเมือง หรือปรัชญา ข้าพเจ้ายินยอมอย่างชัดแจ้งให้ Give Protocol ประมวลผลบันทึกนี้เพื่อดำเนินการและจัดการการบริจาคของข้าพเจ้าให้เสร็จสมบูรณ์",
    "donation.art9Consent.label": "ความยินยอมข้อมูลการบริจาค",
    "donation.art9Consent.required":
      "คุณต้องยินยอมให้ประมวลผลข้อมูลการบริจาคเพื่อดำเนินการต่อ",

    "charity.toast.verificationEmailSent": "Verification email sent",
    "charity.toast.verificationEmailMessage":
      "Check your inbox — the link expires in 24 hours.",
    "charity.toast.submissionFailed": "Submission failed",

    "privacy.security.auditLog":
      "ในฐานะมาตรการทางเทคนิคภายใต้มาตรา 32 ของ GDPR เราบันทึกและตรวจสอบการเข้าถึงข้อมูลส่วนบุคคลโดยผู้ดูแลระบบ ซึ่งรวมถึงการดำเนินการที่ทำและเวลาที่เกิดขึ้น เพื่อตรวจจับการเข้าถึงโดยไม่ได้รับอนุญาต แสดงความรับผิดชอบ และสร้างลำดับเหตุการณ์ใหม่ในกรณีที่ไม่น่าจะเกิดขึ้นของการละเมิดข้อมูลส่วนบุคคล (มาตรา 34) ข้อมูลส่วนบุคคลของผู้บริจาคจะไม่ถูกคัดลอกไปยังบันทึกการเข้าถึงของผู้ดูแลระบบเหล่านี้ บันทึกการเข้าถึงของผู้ดูแลระบบแยกต่างหากจากบันทึกการยืนยันตัวตนและความปลอดภัยที่อธิบายไว้ใน §7.1 ระยะเวลาการเก็บรักษาอยู่ภายใต้บันทึกกิจกรรมการประมวลผลภายในของเรา",

    // Remaining i18n keys — batch translation
    "admin.auditTrail.filterByAction": "กรองตามการดำเนินการ",
    "admin.auditTrail.allActions": "การดำเนินการทั้งหมด",
    "admin.auditTrail.action.charityStatusChange":
      "การเปลี่ยนสถานะองค์กรการกุศล",
    "admin.auditTrail.action.userStatusChange": "การเปลี่ยนสถานะผู้ใช้",
    "admin.auditTrail.action.donationFlag": "การตั้งค่าสถานะการบริจาค",
    "admin.auditTrail.action.donationFlagResolve":
      "การแก้ไขสถานะการบริจาคที่ถูกตั้งค่าสถานะ",
    "admin.auditTrail.action.validationOverride": "การยกเลิกการตรวจสอบ",
    "admin.auditTrail.action.configChange": "การเปลี่ยนแปลงการตั้งค่าระบบ",
    "admin.auditTrail.action.verificationApprove": "การอนุมัติการยืนยันตัวตน",
    "admin.auditTrail.action.verificationReject": "การปฏิเสธการยืนยันตัวตน",
    "admin.auditTrail.action.charitySuspend": "การระงับองค์กรการกุศล",
    "admin.auditTrail.action.charityReinstate": "การคืนสถานะองค์กรการกุศล",
    "admin.auditTrail.action.userSuspend": "การระงับผู้ใช้",
    "admin.auditTrail.action.userReinstate": "การคืนสถานะผู้ใช้",
    "admin.auditTrail.action.userBan": "การแบนผู้ใช้",
    "admin.auditTrail.action.viewPii": "การดูข้อมูลส่วนบุคคล (PII)",
    "admin.auditTrail.action.viewPiiList": "การดูรายการข้อมูลส่วนบุคคล (PII)",
    "admin.auditTrail.viewedEntity":
      "ผู้ดูแลระบบ {{adminId}} ดู {{entityType}} {{entityId}}",
    "admin.auditTrail.viewedList":
      "ผู้ดูแลระบบ {{adminId}} ดูรายการ {{entityType}} (หน้า {{page}}, ตัวกรอง: {{filters}})",
    "admin.auditTrail.viewedListNoFilters":
      "ผู้ดูแลระบบ {{adminId}} ดูรายการ {{entityType}} (หน้า {{page}})",
    "admin.actions.platformNews": "ข่าวสารแพลตฟอร์ม",
    "admin.actions.platformNewsDesc": "จัดการรายการข่าวสารบนหน้าเรียกดู",
    "admin.news.activate": "เผยแพร่ {{title}}",
    "admin.news.activated": "เผยแพร่รายการข่าวสารแล้ว",
    "admin.news.activeLabel": "เผยแพร่แล้ว (สาธารณชนมองเห็นได้)",
    "admin.news.categoryLabel": "หมวดหมู่",
    "admin.news.contentLabel": "เนื้อหา / ข้อความย่อ",
    "admin.news.contentPlaceholder": "คำอธิบายสั้น ๆ ของรายการข่าวสาร...",
    "admin.news.createNews": "สร้างรายการข่าวสาร",
    "admin.news.createNewsBtn": "สร้างข่าวสาร",
    "admin.news.created": "สร้างรายการข่าวสารแล้ว",
    "admin.news.dateLabel": "วันที่เผยแพร่",
    "admin.news.deactivate": "ยกเลิกการเผยแพร่ {{title}}",
    "admin.news.deactivated": "ซ่อนรายการข่าวสารแล้ว",
    "admin.news.deleteItem": "ลบ {{title}}",
    "admin.news.deleted": "ลบรายการข่าวสารแล้ว",
    "admin.news.editItem": "แก้ไข {{title}}",
    "admin.news.editNews": "แก้ไขรายการข่าวสาร",
    "admin.news.imageLabel": "URL รูปภาพ (ไม่บังคับ)",
    "admin.news.imagePlaceholder": "https://...",
    "admin.news.inactive": "ไม่ได้เผยแพร่",
    "admin.news.newItem": "รายการใหม่",
    "admin.news.noItemsMessage":
      "สร้างรายการข่าวสารแรกของคุณเพื่อแบ่งปันความคืบหน้ากับชุมชนของคุณ",
    "admin.news.noItemsYet": "ยังไม่มีรายการข่าวสาร",
    "admin.news.publishedOn": "เผยแพร่เมื่อ {{date}}",
    "admin.news.saving": "กำลังบันทึก...",
    "admin.news.subtitle": "จัดการรายการข่าวสารที่แสดงบนหน้าเรียกดูสาธารณะ",
    "admin.news.title": "ข่าวสารแพลตฟอร์ม",
    "admin.news.titleLabel": "ชื่อเรื่อง",
    "admin.news.titlePlaceholder": "เช่น รายงานผลกระทบรายไตรมาส",
    "admin.news.updateNews": "อัปเดตข่าวสาร",
    "admin.news.updated": "อัปเดตรายการข่าวสารแล้ว",
    "admin.news.urlLabel": "URL ลิงก์",
    "admin.news.urlPlaceholder": "https://example.org/article",
    "charity.walletBadge.institutionalLabel": "ฝากไว้ที่ {{custodianName}}",
    "charity.walletBadge.institutionalTooltip":
      "การบริจาคจะไปยังกระเป๋าเงินที่ดูแลโดยผู้รับฝากทรัพย์สินระดับสถาบันที่มีคุณสมบัติเหมาะสม",
    "charity.walletBadge.safeLabel":
      "คลังมัลติซิก · ผู้ลงนาม {{threshold}} จาก {{count}} คน",
    "charity.walletBadge.safeTooltip":
      "การบริจาคจะไปยังกระเป๋าเงินแบบหลายลายเซ็นที่ต้องได้รับการอนุมัติจากหลายฝ่ายก่อนโอนเงินได้",
    "wallet.eoa.chain": "เครือข่าย",
    "wallet.eoa.checkAuthorized":
      "ข้าพเจ้าได้รับอนุญาตจากองค์กรของข้าพเจ้าให้กำหนดกระเป๋าเงินนี้เป็นที่อยู่รับการบริจาคเพื่อการกุศล",
    "wallet.eoa.checkRisk":
      "ข้าพเจ้าเข้าใจว่ากระเป๋าเงินแบบผู้ลงนามคนเดียวมีความเสี่ยงสูงกว่ากระเป๋าเงินแบบมัลติซิก และการสูญเสียคีย์ส่วนตัวหมายถึงการสูญเสียเงินทุนอย่างถาวร",
    "wallet.eoa.confirmSubtitle":
      "โปรดยืนยันข้อมูลต่อไปนี้ก่อนลงทะเบียนกระเป๋าเงินนี้",
    "wallet.eoa.confirmTitle": "การยืนยันขั้นสุดท้าย",
    "wallet.eoa.connectFirst": "โปรดเชื่อมต่อกระเป๋าเงินของคุณก่อน",
    "wallet.eoa.connectWallet": "เชื่อมต่อกระเป๋าเงิน",
    "wallet.eoa.missingSignature":
      "ไม่มีลายเซ็น โปรดย้อนกลับและลงลายเซ็นอีกครั้ง",
    "wallet.eoa.proceedAnyway": "เข้าใจแล้ว ดำเนินการต่อ",
    "wallet.eoa.register": "ลงทะเบียนกระเป๋าเงิน",
    "wallet.eoa.registering": "กำลังลงทะเบียน...",
    "wallet.eoa.rejected": "คำขอลงลายเซ็นถูกปฏิเสธ",
    "wallet.eoa.riskParagraph1":
      "กระเป๋าเงินแบบผู้ลงนามคนเดียว (EOA) ถูกควบคุมโดยคีย์ส่วนตัวเพียงหนึ่งเดียว หากคีย์นี้สูญหาย ถูกขโมย หรือถูกบุกรุก เงินทุนทั้งหมดที่ส่งไปยังกระเป๋าเงินนี้จะไม่สามารถกู้คืนได้อย่างถาวร",
    "wallet.eoa.riskParagraph2":
      "สำหรับเงินทุนขององค์กร เราขอแนะนำอย่างยิ่งให้ใช้กระเป๋าเงิน Safe แบบมัลติซิกแทน กระเป๋าเงินแบบมัลติซิกต้องได้รับการอนุมัติจากหลายฝ่ายสำหรับทุกธุรกรรม ช่วยป้องกันความล้มเหลวจากจุดเดียว",
    "wallet.eoa.riskParagraph3":
      "การดำเนินการต่อถือว่าคุณรับทราบว่า Give Protocol จะไม่รับผิดชอบต่อการสูญเสียเงินทุนใด ๆ อันเนื่องมาจากการถูกบุกรุก การสูญหาย หรือการจัดการคีย์ส่วนตัวที่ผิดพลาด",
    "wallet.eoa.riskTitle": "กระเป๋าเงินแบบผู้ลงนามคนเดียว: ความเสี่ยงที่สำคัญ",
    "wallet.eoa.signError": "ลงลายเซ็นข้อความไม่สำเร็จ โปรดลองอีกครั้ง",
    "wallet.eoa.signMessage": "ลงลายเซ็นข้อความยืนยันตัวตน",
    "wallet.eoa.signSubtitle":
      "เชื่อมต่อกระเป๋าเงินของคุณและลงลายเซ็นข้อความเพื่อพิสูจน์ว่าคุณควบคุมที่อยู่นี้",
    "wallet.eoa.signTitle": "เชื่อมต่อและลงลายเซ็น",
    "wallet.eoa.useMultisig": "ใช้กระเป๋าเงินแบบมัลติซิกแทน",
    "wallet.eoa.walletConnection": "กระเป๋าเงิน",
    "wallet.eoa.walletToRegister": "กระเป๋าเงินที่จะลงทะเบียน",
    "wallet.institutional.address": "ที่อยู่กระเป๋าเงิน",
    "wallet.institutional.attestation": "เอกสารรับรอง",
    "wallet.institutional.attestationHelp":
      "อัปโหลดไฟล์ PDF, JPEG หรือ PNG (สูงสุด 10MB) เพื่อพิสูจน์ความสัมพันธ์กับผู้รับฝากทรัพย์สินของคุณ",
    "wallet.institutional.backToWallets": "กลับไปยังกระเป๋าเงิน",
    "wallet.institutional.chain": "เครือข่าย",
    "wallet.institutional.chooseFile": "เลือกไฟล์หรือลากและวาง",
    "wallet.institutional.custodian": "ผู้รับฝากทรัพย์สิน",
    "wallet.institutional.fileTooLarge": "ไฟล์ต้องมีขนาดเล็กกว่า 10MB",
    "wallet.institutional.invalidAddress":
      "โปรดป้อนที่อยู่ Ethereum ที่ถูกต้อง (0x...)",
    "wallet.institutional.invalidFileType":
      "โปรดอัปโหลดไฟล์ PDF, JPEG หรือ PNG",
    "wallet.institutional.removeFile": "ลบไฟล์",
    "wallet.institutional.selectCustodian": "โปรดเลือกผู้รับฝากทรัพย์สิน",
    "wallet.institutional.selectCustodianOption": "เลือกผู้รับฝากทรัพย์สิน...",
    "wallet.institutional.submit": "ส่งเพื่อตรวจสอบ",
    "wallet.institutional.submittedDesc":
      "การลงทะเบียนกระเป๋าเงินสถาบันของคุณอยู่ระหว่างการตรวจสอบ คุณจะได้รับอีเมลภายใน 3 วันทำการ",
    "wallet.institutional.submittedTitle": "ส่งกระเป๋าเงินเพื่อตรวจสอบแล้ว",
    "wallet.institutional.submitting": "กำลังส่ง...",
    "wallet.institutional.subtitle":
      "ระบุรายละเอียดกระเป๋าเงินที่ดูแลโดยผู้รับฝากทรัพย์สินของคุณ และอัปโหลดเอกสารรับรองเพื่อการตรวจสอบ",
    "wallet.institutional.title": "ลงทะเบียนกระเป๋าเงินฝากทรัพย์สินระดับสถาบัน",
    "wallet.institutional.uploadFile": "อัปโหลดไฟล์เอกสารรับรอง",
    "wallet.institutional.uploadRequired": "โปรดอัปโหลดเอกสารรับรอง",
    "wallet.safe.address": "ที่อยู่ Safe",
    "wallet.safe.chain": "เครือข่าย",
    "wallet.safe.connectFirst": "โปรดเชื่อมต่อกระเป๋าเงินผู้ลงนามของคุณก่อน",
    "wallet.safe.connectSigner": "เชื่อมต่อกระเป๋าเงินผู้ลงนาม",
    "wallet.safe.createNew": "สร้าง Safe ใหม่",
    "wallet.safe.createNewDesc":
      "เปิด app.safe.global ซึ่งคุณสามารถสร้างมัลติซิกใหม่ได้ที่นั่น กลับมาที่นี่อีกครั้งเมื่อปรับใช้เรียบร้อยแล้ว",
    "wallet.safe.haveOne": "ข้าพเจ้ามี Safe อยู่แล้ว",
    "wallet.safe.haveOneDesc":
      "ป้อนที่อยู่ Safe ของคุณและยืนยันการควบคุมโดยการลงลายเซ็นข้อความจากกระเป๋าเงินผู้ลงนาม",
    "wallet.safe.invalidAddress": "โปรดป้อนที่อยู่ Ethereum ที่ถูกต้อง (0x...)",
    "wallet.safe.rejected": "คำขอลงลายเซ็นถูกปฏิเสธ",
    "wallet.safe.signError": "ลงลายเซ็นข้อความยืนยันไม่สำเร็จ โปรดลองอีกครั้ง",
    "wallet.safe.signVerify": "ลงลายเซ็นเพื่อยืนยันการควบคุม",
    "wallet.safe.signerWallet": "กระเป๋าเงินผู้ลงนาม",
    "wallet.safe.subtitle":
      "Safe ต้องการผู้ลงนามหลายคนในการอนุมัติทุกธุรกรรม ให้ระดับความปลอดภัยสูงสุดสำหรับเงินทุนขององค์กรการกุศลของคุณ",
    "wallet.safe.title": "ตั้งค่ากระเป๋าเงินมัลติซิก Safe",
    "wallet.safe.verifyTitle": "ยืนยันความเป็นเจ้าของ Safe",
    "wallet.safe.verifying": "กำลังยืนยัน...",
    "wallet.setup.addAnother": "เพิ่มอีกรายการ",
    "wallet.setup.custodian": "ผู้รับฝากทรัพย์สิน",
    "wallet.setup.deleteFailed": "ลบกระเป๋าเงินไม่สำเร็จ",
    "wallet.setup.eoaDesc":
      "กระเป๋าเงินมาตรฐานที่ควบคุมโดยคีย์ส่วนตัวเพียงหนึ่งเดียว ง่ายที่สุดแต่มีความปลอดภัยน้อยที่สุดสำหรับการใช้งานขององค์กร",
    "wallet.setup.eoaTitle": "ผู้ลงนามคนเดียว (EOA)",
    "wallet.setup.institutionalDesc":
      "ดูแลโดยผู้รับฝากทรัพย์สินที่มีคุณสมบัติเหมาะสม (Fireblocks, Anchorage เป็นต้น) ต้องใช้เอกสารรับรอง",
    "wallet.setup.institutionalTitle": "การฝากทรัพย์สินระดับสถาบัน",
    "wallet.setup.makePrimary": "ตั้งเป็นค่าเริ่มต้น",
    "wallet.setup.primary": "ค่าเริ่มต้น",
    "wallet.setup.primaryFailed": "อัปเดตกระเป๋าเงินหลักไม่สำเร็จ",
    "wallet.setup.primaryUpdated": "อัปเดตกระเป๋าเงินหลักแล้ว",
    "wallet.setup.recommended": "แนะนำ",
    "wallet.setup.remove": "ลบกระเป๋าเงิน",
    "wallet.setup.safeDesc":
      "ต้องมีผู้ลงนามหลายคนสำหรับทุกธุรกรรม ความปลอดภัยสูงสุดสำหรับเงินทุนขององค์กร",
    "wallet.setup.safeSigners": "ผู้ลงนาม",
    "wallet.setup.safeTitle": "Safe แบบมัลติซิก",
    "wallet.setup.subtitle":
      "เลือกวิธีที่องค์กรการกุศลของคุณจะรับการบริจาคคริปโต เราแนะนำกระเป๋าเงินแบบมัลติซิกเพื่อความปลอดภัยสูงสุด",
    "wallet.setup.title": "ตั้งค่ากระเป๋าเงินสำหรับรับเงิน",
    "wallet.setup.viewExplorer": "ดูบน block explorer",
    "wallet.setup.walletAdded": "ลงทะเบียนกระเป๋าเงินสำเร็จ",
    "wallet.setup.walletDeleted": "ลบกระเป๋าเงินแล้ว",
    "wallet.setup.walletsTitle": "กระเป๋าเงินสำหรับรับเงิน",
    "admin.nav.dashboard": "แดชบอร์ด",
    "admin.nav.reports": "รายงานและการวิเคราะห์",
    "admin.nav.charities": "องค์กรการกุศล",
    "admin.nav.donations": "การบริจาค",
    "admin.nav.impactMetrics": "ตัวชี้วัดผลกระทบ",
    "admin.nav.portfolioFunds": "กองทุนพอร์ตโฟลิโอ",
    "admin.nav.contentModeration": "การกลั่นกรองเนื้อหา",
    "admin.nav.settings": "การตั้งค่าระบบ",
    "admin.nav.overview": "ภาพรวม",
    "admin.nav.operations": "การดำเนินงาน",
    "admin.nav.consoleLabel": "คอนโซลผู้ดูแลระบบ",
    "admin.shell.searchPlaceholder": "ค้นหาผู้บริจาค องค์กรการกุศล แฮชธุรกรรม…",
    "admin.shell.searchLabel": "ค้นหาในคอนโซลผู้ดูแลระบบ",
    "admin.shell.notifications": "การแจ้งเตือน",
    "admin.shell.adminLabel": "ผู้ดูแลระบบ",
    "admin.shell.superAdmin": "ผู้ดูแลระบบสูงสุด",
    "admin.shell.signOut": "ออกจากระบบ",
    "admin.shell.backToPublicSite": "กลับไปยังเว็บไซต์สาธารณะ",
    "admin.shell.homeLink": "หน้าแรก Give Protocol",
    "admin.dashboard.severityHigh": "ความสำคัญสูง",
    "admin.dashboard.severityMedium": "ต้องให้ความสนใจ",
    "admin.dashboard.severityLow": "รอการตรวจสอบ",
    "admin.dashboard.alertOldest": "คำขอที่ส่งมานานที่สุด",
    "admin.dashboard.alertReviewHint":
      "ตรวจสอบเพื่อให้กระบวนการเริ่มต้นใช้งานดำเนินต่อไป",
    "admin.dashboard.reviewQueue": "คิวการตรวจสอบ",
    "admin.dashboard.kpiDonorsSub": "ใหม่ {{count}} รายการใน 30 วันที่ผ่านมา",
    "admin.dashboard.kpiPending": "รอดำเนินการ {{count}} รายการ",
    "admin.dashboard.awaitingVerification": "รอการยืนยันตัวตน",
    "admin.dashboard.kpiVerifiedSub":
      "จากทั้งหมด {{total}} รายการที่อนุมัติแล้ว",
    "admin.dashboard.kpiVolunteersActive": "การสมัครที่ใช้งานอยู่",
    "admin.dashboard.kpiVolunteersSub": "ไม่มีการสมัครที่ใช้งานอยู่",
    "admin.dashboard.donationVolume": "ปริมาณการบริจาค",
    "admin.dashboard.donationVolumeSub": "{{range}} · รวมคริปโตและเงินตรา",
    "admin.dashboard.range30d": "30 วันที่ผ่านมา",
    "admin.dashboard.range90d": "90 วันที่ผ่านมา",
    "admin.dashboard.rangeYtd": "ตั้งแต่ต้นปีถึงปัจจุบัน",
    "admin.dashboard.volumeEmptyTitle": "ยังไม่มีการบันทึกการบริจาค",
    "admin.dashboard.volumeEmptySub":
      "ปริมาณจะแสดงเป็นกราฟที่นี่เมื่อการบริจาคครั้งแรกดำเนินการเสร็จสมบูรณ์",
    "admin.dashboard.totalVolume": "ปริมาณรวม",
    "admin.dashboard.crypto": "คริปโต",
    "admin.dashboard.fiat": "เงินตรา",
    "admin.dashboard.activitySubtitle": "เหตุการณ์บนแพลตฟอร์มตามเวลาจริง",
    "admin.dashboard.viewAllActivity": "ดูกิจกรรมทั้งหมด",
    "admin.dashboard.viewAllDonations": "ดูการบริจาคทั้งหมด",
    "admin.charity.tabAll": "ทั้งหมด",
    "admin.charity.review": "ตรวจสอบ",
    "admin.charity.colOrganization": "องค์กร",
    "admin.charity.colRaised": "ยอดระดมทุน",
    "admin.charity.colSubmitted": "วันที่ส่ง",
    "admin.charity.searchAria": "ค้นหาองค์กรการกุศล",
    "admin.charity.reviewTitle": "ตรวจสอบ {{name}}",
    "admin.charity.submittedRelative": "ส่งเมื่อ {{when}}",
    "admin.charity.contactEmail": "อีเมล",
    "admin.charity.contactPhone": "โทรศัพท์",
    "admin.charity.raisedUnavailable": "ไม่มีข้อมูลยอดบริจาครวม",
    "admin.error.title": "ข้อผิดพลาดในการโหลดข้อมูล",
    "admin.error.recentActivity": "ข้อผิดพลาดในการโหลดกิจกรรมล่าสุด",
    "admin.error.alerts": "ข้อผิดพลาดในการโหลดการแจ้งเตือน",
    "admin.error.donationVolume": "ข้อผิดพลาดในการโหลดปริมาณการบริจาค",
    "donation.gas.estimating": "กำลังประมาณค่าธรรมเนียมเครือข่าย…",
    "donation.gas.label": "ค่าธรรมเนียมเครือข่ายโดยประมาณ",
    "donation.gas.highGasWarning":
      "แจ้งเตือนค่าแก๊สสูง: ค่าธรรมเนียมโดยประมาณคือ {{usd}} ซึ่งคิดเป็น {{pct}} ของยอดบริจาคของคุณ",
    "donation.gas.highGasSuggestion":
      "ลองพิจารณาบริจาคในจำนวนที่มากขึ้น หรือเปลี่ยนไปใช้เครือข่ายที่มีค่าธรรมเนียมต่ำกว่า",
    "donation.gas.l2Hint": "หากต้องการค่าธรรมเนียมที่ต่ำลง ลองใช้ {{chains}}",
  },
};
